/* tslint:disable */
/* eslint-disable */
/**
 * Example API
 * API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  Account,
  Chat,
  ConfirmUploadRequest,
  Country,
  CreateCountryDto,
  CreateDayDto,
  CreateFollowRequest,
  CreateItineraryRequest,
  CreateLegDto,
  CreateOrderRequest,
  CreatePlaceDto,
  CreatePostRequest,
  CreateReactionRequest,
  CreateStopDto,
  CreditPackage,
  Day,
  Follow,
  GenerateSASToken201Response,
  GenerateSASTokenRequest,
  GetChatHistory200ResponseInner,
  Image,
  Itinerary,
  ItineraryProjection,
  Leg,
  Order,
  Place,
  Post,
  Reaction,
  SearchAccounts200Response,
  SearchAndSavePreviewImagesByWordRequest,
  SearchAndSavePreviewImagesForItineraryRequest,
  SearchAndSavePreviewImagesForStopRequest,
  SearchItineraries200Response,
  SearchStops200Response,
  SendMessageToThread402Response,
  SendMessageToThreadRequest,
  Stop,
  StopProjection,
  UpdateAccountDto,
  UpdateDayRequest,
  UpdateLegRequest,
  UpdateStopRequest,
  VerifyIAPReceiptRequest,
} from '../models/index';
import {
    AccountFromJSON,
    AccountToJSON,
    ChatFromJSON,
    ChatToJSON,
    ConfirmUploadRequestFromJSON,
    ConfirmUploadRequestToJSON,
    CountryFromJSON,
    CountryToJSON,
    CreateCountryDtoFromJSON,
    CreateCountryDtoToJSON,
    CreateDayDtoFromJSON,
    CreateDayDtoToJSON,
    CreateFollowRequestFromJSON,
    CreateFollowRequestToJSON,
    CreateItineraryRequestFromJSON,
    CreateItineraryRequestToJSON,
    CreateLegDtoFromJSON,
    CreateLegDtoToJSON,
    CreateOrderRequestFromJSON,
    CreateOrderRequestToJSON,
    CreatePlaceDtoFromJSON,
    CreatePlaceDtoToJSON,
    CreatePostRequestFromJSON,
    CreatePostRequestToJSON,
    CreateReactionRequestFromJSON,
    CreateReactionRequestToJSON,
    CreateStopDtoFromJSON,
    CreateStopDtoToJSON,
    CreditPackageFromJSON,
    CreditPackageToJSON,
    DayFromJSON,
    DayToJSON,
    FollowFromJSON,
    FollowToJSON,
    GenerateSASToken201ResponseFromJSON,
    GenerateSASToken201ResponseToJSON,
    GenerateSASTokenRequestFromJSON,
    GenerateSASTokenRequestToJSON,
    GetChatHistory200ResponseInnerFromJSON,
    GetChatHistory200ResponseInnerToJSON,
    ImageFromJSON,
    ImageToJSON,
    ItineraryFromJSON,
    ItineraryToJSON,
    ItineraryProjectionFromJSON,
    ItineraryProjectionToJSON,
    LegFromJSON,
    LegToJSON,
    OrderFromJSON,
    OrderToJSON,
    PlaceFromJSON,
    PlaceToJSON,
    PostFromJSON,
    PostToJSON,
    ReactionFromJSON,
    ReactionToJSON,
    SearchAccounts200ResponseFromJSON,
    SearchAccounts200ResponseToJSON,
    SearchAndSavePreviewImagesByWordRequestFromJSON,
    SearchAndSavePreviewImagesByWordRequestToJSON,
    SearchAndSavePreviewImagesForItineraryRequestFromJSON,
    SearchAndSavePreviewImagesForItineraryRequestToJSON,
    SearchAndSavePreviewImagesForStopRequestFromJSON,
    SearchAndSavePreviewImagesForStopRequestToJSON,
    SearchItineraries200ResponseFromJSON,
    SearchItineraries200ResponseToJSON,
    SearchStops200ResponseFromJSON,
    SearchStops200ResponseToJSON,
    SendMessageToThread402ResponseFromJSON,
    SendMessageToThread402ResponseToJSON,
    SendMessageToThreadRequestFromJSON,
    SendMessageToThreadRequestToJSON,
    StopFromJSON,
    StopToJSON,
    StopProjectionFromJSON,
    StopProjectionToJSON,
    UpdateAccountDtoFromJSON,
    UpdateAccountDtoToJSON,
    UpdateDayRequestFromJSON,
    UpdateDayRequestToJSON,
    UpdateLegRequestFromJSON,
    UpdateLegRequestToJSON,
    UpdateStopRequestFromJSON,
    UpdateStopRequestToJSON,
    VerifyIAPReceiptRequestFromJSON,
    VerifyIAPReceiptRequestToJSON,
} from '../models/index';

export interface ConfirmUploadOperationRequest {
    confirmUploadRequest: ConfirmUploadRequest;
}

export interface CreateCountryRequest {
    createCountryDto: CreateCountryDto;
}

export interface CreateCountry0Request {
    createCountryDto: CreateCountryDto;
}

export interface CreateFollowOperationRequest {
    createFollowRequest: CreateFollowRequest;
}

export interface CreateFollow0Request {
    createFollowRequest: CreateFollowRequest;
}

export interface CreateItineraryOperationRequest {
    createItineraryRequest: CreateItineraryRequest;
}

export interface CreateItineraryDayRequest {
    itineraryId: string;
    createDayDto: CreateDayDto;
}

export interface CreateItineraryDay0Request {
    itineraryId: string;
    createDayDto: CreateDayDto;
}

export interface CreateLegRequest {
    itineraryId: string;
    createLegDto: CreateLegDto;
}

export interface CreateLeg0Request {
    itineraryId: string;
    createLegDto: CreateLegDto;
}

export interface CreateNewChatRequest {
    sendMessageToThreadRequest: SendMessageToThreadRequest;
    itineraryId?: string;
}

export interface CreateOrderOperationRequest {
    accountId: string;
    createOrderRequest: CreateOrderRequest;
}

export interface CreatePlaceRequest {
    createPlaceDto: CreatePlaceDto;
}

export interface CreatePlace0Request {
    createPlaceDto: CreatePlaceDto;
}

export interface CreatePostOperationRequest {
    createPostRequest: CreatePostRequest;
}

export interface CreatePost0Request {
    createPostRequest: CreatePostRequest;
}

export interface CreateReactionOperationRequest {
    createReactionRequest: CreateReactionRequest;
}

export interface CreateReaction0Request {
    createReactionRequest: CreateReactionRequest;
}

export interface CreateStopRequest {
    itineraryId: string;
    createStopDto: CreateStopDto;
}

export interface CreateStop0Request {
    itineraryId: string;
    createStopDto: CreateStopDto;
}

export interface DeleteStopRequest {
    itineraryId: string;
    id: string;
}

export interface DeleteStop0Request {
    itineraryId: string;
    id: string;
}

export interface FindAllAccountRequest {
    page?: number;
    limit?: number;
    sort?: string;
    filter?: string;
    ids?: string;
}

export interface FindAllAccountChatRequest {
    accountId: string;
    page?: number;
    limit?: number;
    sort?: string;
    filter?: string;
    ids?: string;
}

export interface FindAllCountryRequest {
    page?: number;
    limit?: number;
    sort?: string;
    filter?: string;
    ids?: string;
}

export interface FindAllCountry0Request {
    page?: number;
    limit?: number;
    sort?: string;
    filter?: string;
    ids?: string;
}

export interface FindAllFollowRequest {
    page?: number;
    limit?: number;
    sort?: string;
    filter?: string;
    ids?: string;
}

export interface FindAllFollow0Request {
    page?: number;
    limit?: number;
    sort?: string;
    filter?: string;
    ids?: string;
}

export interface FindAllItineraryRequest {
    page?: number;
    limit?: number;
    sort?: string;
    filter?: string;
    ids?: string;
}

export interface FindAllItineraryDayRequest {
    itineraryId: string;
    page?: number;
    limit?: number;
    sort?: string;
    filter?: string;
    ids?: string;
}

export interface FindAllItineraryDay0Request {
    itineraryId: string;
    page?: number;
    limit?: number;
    sort?: string;
    filter?: string;
    ids?: string;
}

export interface FindAllItineraryLegRequest {
    itineraryId: string;
    page?: number;
    limit?: number;
    sort?: string;
    filter?: string;
    ids?: string;
}

export interface FindAllItineraryLeg0Request {
    itineraryId: string;
    page?: number;
    limit?: number;
    sort?: string;
    filter?: string;
    ids?: string;
}

export interface FindAllItineraryStopRequest {
    itineraryId: string;
    page?: number;
    limit?: number;
    sort?: string;
    filter?: string;
    ids?: string;
}

export interface FindAllItineraryStop0Request {
    itineraryId: string;
    page?: number;
    limit?: number;
    sort?: string;
    filter?: string;
    ids?: string;
}

export interface FindAllPlaceRequest {
    page?: number;
    limit?: number;
    sort?: string;
    filter?: string;
    ids?: string;
}

export interface FindAllPlace0Request {
    page?: number;
    limit?: number;
    sort?: string;
    filter?: string;
    ids?: string;
}

export interface FindAllPostRequest {
    page?: number;
    limit?: number;
    sort?: string;
    filter?: string;
    ids?: string;
}

export interface FindAllPost0Request {
    page?: number;
    limit?: number;
    sort?: string;
    filter?: string;
    ids?: string;
}

export interface FindAllReactionRequest {
    page?: number;
    limit?: number;
    sort?: string;
    filter?: string;
    ids?: string;
}

export interface FindAllReaction0Request {
    page?: number;
    limit?: number;
    sort?: string;
    filter?: string;
    ids?: string;
}

export interface FindAllStopRequest {
    page?: number;
    limit?: number;
    sort?: string;
    filter?: string;
    ids?: string;
}

export interface FindAllStop0Request {
    page?: number;
    limit?: number;
    sort?: string;
    filter?: string;
    ids?: string;
}

export interface FindOneAccountRequest {
    id: string;
}

export interface FindOneAccountChatRequest {
    accountId: string;
    id: string;
}

export interface FindOneCountryRequest {
    id: string;
}

export interface FindOneCountry0Request {
    id: string;
}

export interface FindOneFollowRequest {
    id: string;
}

export interface FindOneFollow0Request {
    id: string;
}

export interface FindOneItineraryRequest {
    id: string;
}

export interface FindOneItineraryDayRequest {
    itineraryId: string;
    id: string;
}

export interface FindOneItineraryDay0Request {
    itineraryId: string;
    id: string;
}

export interface FindOneItineraryLegRequest {
    itineraryId: string;
    id: string;
}

export interface FindOneItineraryLeg0Request {
    itineraryId: string;
    id: string;
}

export interface FindOneItineraryStopRequest {
    itineraryId: string;
    id: string;
}

export interface FindOneItineraryStop0Request {
    itineraryId: string;
    id: string;
}

export interface FindOnePlaceRequest {
    id: string;
}

export interface FindOnePlace0Request {
    id: string;
}

export interface FindOnePostRequest {
    id: string;
}

export interface FindOnePost0Request {
    id: string;
}

export interface FindOneReactionRequest {
    id: string;
}

export interface FindOneReaction0Request {
    id: string;
}

export interface FindOneStopRequest {
    id: string;
}

export interface FindOneStop0Request {
    id: string;
}

export interface GenerateSASTokenOperationRequest {
    generateSASTokenRequest: GenerateSASTokenRequest;
}

export interface GetChatHistoryRequest {
    threadId: string;
    itineraryId?: string;
}

export interface GetCreditPackagesRequest {
    accountId: string;
}

export interface GetItinerariesByBoundsRequest {
    southWestLng: number;
    southWestLat: number;
    northEastLng: number;
    northEastLat: number;
    limit?: number;
    page?: number;
}

export interface GetOrderRequest {
    accountId: string;
    id: string;
}

export interface GetOrdersRequest {
    accountId: string;
}

export interface RemoveAccountRequest {
    id: string;
}

export interface RemoveCountryRequest {
    id: string;
}

export interface RemoveCountry0Request {
    id: string;
}

export interface RemoveDayRequest {
    itineraryId: string;
    id: string;
}

export interface RemoveDay0Request {
    itineraryId: string;
    id: string;
}

export interface RemoveFollowRequest {
    followingId: string;
}

export interface RemoveFollow0Request {
    followingId: string;
}

export interface RemoveItineraryRequest {
    id: string;
}

export interface RemoveLegRequest {
    itineraryId: string;
    id: string;
}

export interface RemoveLeg0Request {
    itineraryId: string;
    id: string;
}

export interface RemoveManyAccountsRequest {
    filter: string;
}

export interface RemoveManyCountrysRequest {
    filter: string;
}

export interface RemoveManyCountrys0Request {
    filter: string;
}

export interface RemoveManyDaysRequest {
    itineraryId: string;
    filter: string;
}

export interface RemoveManyDays0Request {
    itineraryId: string;
    filter: string;
}

export interface RemoveManyFollowsRequest {
    filter: string;
}

export interface RemoveManyFollows0Request {
    filter: string;
}

export interface RemoveManyItinerarysRequest {
    filter: string;
}

export interface RemoveManyLegsRequest {
    itineraryId: string;
    filter: string;
}

export interface RemoveManyLegs0Request {
    itineraryId: string;
    filter: string;
}

export interface RemoveManyPlacesRequest {
    filter: string;
}

export interface RemoveManyPlaces0Request {
    filter: string;
}

export interface RemoveManyPostsRequest {
    filter: string;
}

export interface RemoveManyPosts0Request {
    filter: string;
}

export interface RemoveManyReactionsRequest {
    filter: string;
}

export interface RemoveManyReactions0Request {
    filter: string;
}

export interface RemovePlaceRequest {
    id: string;
}

export interface RemovePlace0Request {
    id: string;
}

export interface RemovePostRequest {
    id: string;
}

export interface RemovePost0Request {
    id: string;
}

export interface RemoveReactionRequest {
    reactableType: RemoveReactionReactableTypeEnum;
    reactableId: string;
    reactionType: RemoveReactionReactionTypeEnum;
}

export interface RemoveReaction0Request {
    reactableType: RemoveReaction0ReactableTypeEnum;
    reactableId: string;
    reactionType: RemoveReaction0ReactionTypeEnum;
}

export interface SearchAccountsRequest {
    q: string;
    limit?: number;
    page?: number;
    minScore?: number;
    fuzzyMatch?: boolean;
}

export interface SearchAndSavePreviewImagesByWordOperationRequest {
    searchAndSavePreviewImagesByWordRequest: SearchAndSavePreviewImagesByWordRequest;
}

export interface SearchAndSavePreviewImagesForItineraryOperationRequest {
    itineraryId: string;
    searchAndSavePreviewImagesForItineraryRequest: SearchAndSavePreviewImagesForItineraryRequest;
}

export interface SearchAndSavePreviewImagesForStopOperationRequest {
    itineraryId: string;
    searchAndSavePreviewImagesForStopRequest: SearchAndSavePreviewImagesForStopRequest;
}

export interface SearchAndSavePreviewImagesForStop0Request {
    itineraryId: string;
    searchAndSavePreviewImagesForStopRequest: SearchAndSavePreviewImagesForStopRequest;
}

export interface SearchItinerariesRequest {
    q: string;
    limit?: number;
    page?: number;
    minScore?: number;
    fuzzyMatch?: boolean;
    visibility?: SearchItinerariesVisibilityEnum;
}

export interface SearchStopsRequest {
    q: string;
    limit?: number;
    page?: number;
    minScore?: number;
    fuzzyMatch?: boolean;
    country?: string;
    city?: string;
}

export interface SendMessageToThreadOperationRequest {
    id: string;
    sendMessageToThreadRequest: SendMessageToThreadRequest;
    itineraryId?: string;
}

export interface UpdateAccountRequest {
    id: string;
    updateAccountDto: UpdateAccountDto;
}

export interface UpdateCountryRequest {
    id: string;
    country: Omit<Country, 'id'|'createdAt'|'updatedAt'>;
}

export interface UpdateCountry0Request {
    id: string;
    country: Omit<Country, 'id'|'createdAt'|'updatedAt'>;
}

export interface UpdateDayOperationRequest {
    itineraryId: string;
    id: string;
    updateDayRequest: UpdateDayRequest;
}

export interface UpdateDay0Request {
    itineraryId: string;
    id: string;
    updateDayRequest: UpdateDayRequest;
}

export interface UpdateFollowRequest {
    id: string;
    follow: Omit<Follow, 'id'|'follower'|'followerId'|'following'|'followingId'|'createdAt'|'updatedAt'>;
}

export interface UpdateFollow0Request {
    id: string;
    follow: Omit<Follow, 'id'|'follower'|'followerId'|'following'|'followingId'|'createdAt'|'updatedAt'>;
}

export interface UpdateItineraryRequest {
    id: string;
    itinerary: Omit<Itinerary, 'id'|'image'|'imageId'|'createdAt'|'updatedAt'|'stopsCount'|'stopIds'|'daysCount'|'dayIds'|'legsCount'|'legIds'|'account'|'accountId'|'countryIds'>;
}

export interface UpdateLegOperationRequest {
    itineraryId: string;
    id: string;
    updateLegRequest: UpdateLegRequest;
}

export interface UpdateLeg0Request {
    itineraryId: string;
    id: string;
    updateLegRequest: UpdateLegRequest;
}

export interface UpdateManyAccountsRequest {
    filter: string;
    account: Omit<Account, 'id'|'createdAt'|'updatedAt'|'orderIds'>;
}

export interface UpdateManyCountrysRequest {
    filter: string;
    country: Omit<Country, 'id'|'createdAt'|'updatedAt'>;
}

export interface UpdateManyCountrys0Request {
    filter: string;
    country: Omit<Country, 'id'|'createdAt'|'updatedAt'>;
}

export interface UpdateManyDaysRequest {
    itineraryId: string;
    filter: string;
    day: Omit<Day, 'id'|'createdAt'|'updatedAt'|'itineraryId'>;
}

export interface UpdateManyDays0Request {
    itineraryId: string;
    filter: string;
    day: Omit<Day, 'id'|'createdAt'|'updatedAt'|'itineraryId'>;
}

export interface UpdateManyFollowsRequest {
    filter: string;
    follow: Omit<Follow, 'id'|'follower'|'followerId'|'following'|'followingId'|'createdAt'|'updatedAt'>;
}

export interface UpdateManyFollows0Request {
    filter: string;
    follow: Omit<Follow, 'id'|'follower'|'followerId'|'following'|'followingId'|'createdAt'|'updatedAt'>;
}

export interface UpdateManyItinerarysRequest {
    filter: string;
    itinerary: Omit<Itinerary, 'id'|'image'|'imageId'|'createdAt'|'updatedAt'|'stopsCount'|'stopIds'|'daysCount'|'dayIds'|'legsCount'|'legIds'|'account'|'accountId'|'countryIds'>;
}

export interface UpdateManyLegsRequest {
    itineraryId: string;
    filter: string;
    leg: Omit<Leg, 'id'|'createdAt'|'updatedAt'|'fromStopId'|'toStopId'|'itineraryId'|'fromCoordinates'|'toCoordinates'>;
}

export interface UpdateManyLegs0Request {
    itineraryId: string;
    filter: string;
    leg: Omit<Leg, 'id'|'createdAt'|'updatedAt'|'fromStopId'|'toStopId'|'itineraryId'|'fromCoordinates'|'toCoordinates'>;
}

export interface UpdateManyPlacesRequest {
    filter: string;
    place: Omit<Place, 'id'|'createdAt'|'updatedAt'>;
}

export interface UpdateManyPlaces0Request {
    filter: string;
    place: Omit<Place, 'id'|'createdAt'|'updatedAt'>;
}

export interface UpdateManyPostsRequest {
    filter: string;
    post: Omit<Post, 'id'|'createdAt'|'updatedAt'|'account'|'accountId'|'file'|'fileId'>;
}

export interface UpdateManyPosts0Request {
    filter: string;
    post: Omit<Post, 'id'|'createdAt'|'updatedAt'|'account'|'accountId'|'file'|'fileId'>;
}

export interface UpdateManyReactionsRequest {
    filter: string;
    reaction: Omit<Reaction, 'id'|'createdAt'|'updatedAt'|'account'|'accountId'>;
}

export interface UpdateManyReactions0Request {
    filter: string;
    reaction: Omit<Reaction, 'id'|'createdAt'|'updatedAt'|'account'|'accountId'>;
}

export interface UpdatePlaceRequest {
    id: string;
    place: Omit<Place, 'id'|'createdAt'|'updatedAt'>;
}

export interface UpdatePlace0Request {
    id: string;
    place: Omit<Place, 'id'|'createdAt'|'updatedAt'>;
}

export interface UpdatePostRequest {
    id: string;
    post: Omit<Post, 'id'|'createdAt'|'updatedAt'|'account'|'accountId'|'file'|'fileId'>;
}

export interface UpdatePost0Request {
    id: string;
    post: Omit<Post, 'id'|'createdAt'|'updatedAt'|'account'|'accountId'|'file'|'fileId'>;
}

export interface UpdateReactionRequest {
    id: string;
    reaction: Omit<Reaction, 'id'|'createdAt'|'updatedAt'|'account'|'accountId'>;
}

export interface UpdateReaction0Request {
    id: string;
    reaction: Omit<Reaction, 'id'|'createdAt'|'updatedAt'|'account'|'accountId'>;
}

export interface UpdateStopOperationRequest {
    itineraryId: string;
    id: string;
    updateStopRequest: UpdateStopRequest;
}

export interface UpdateStop0Request {
    itineraryId: string;
    id: string;
    updateStopRequest: UpdateStopRequest;
}

export interface UploadFileRequest {
    file: Blob;
}

export interface VerifyIAPReceiptOperationRequest {
    accountId: string;
    verifyIAPReceiptRequest: VerifyIAPReceiptRequest;
}

/**
 * 
 */
export class CitySageApi extends runtime.BaseAPI {

    /**
     * Confirm that a direct upload to Azure was successful and create a File record
     * Confirm direct Azure upload
     */
    async confirmUploadRaw(requestParameters: ConfirmUploadOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        if (requestParameters['confirmUploadRequest'] == null) {
            throw new runtime.RequiredError(
                'confirmUploadRequest',
                'Required parameter "confirmUploadRequest" was null or undefined when calling confirmUpload().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/files/confirmation`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ConfirmUploadRequestToJSON(requestParameters['confirmUploadRequest']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Confirm that a direct upload to Azure was successful and create a File record
     * Confirm direct Azure upload
     */
    async confirmUpload(requestParameters: ConfirmUploadOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.confirmUploadRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a new Account
     */
    async createAccountRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Account>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/accounts`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AccountFromJSON(jsonValue));
    }

    /**
     * Create a new Account
     */
    async createAccount(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Account> {
        const response = await this.createAccountRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates a new country with the provided details. Admin access required.
     * Create a new country
     */
    async createCountryRaw(requestParameters: CreateCountryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Country>> {
        if (requestParameters['createCountryDto'] == null) {
            throw new runtime.RequiredError(
                'createCountryDto',
                'Required parameter "createCountryDto" was null or undefined when calling createCountry().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/countries`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateCountryDtoToJSON(requestParameters['createCountryDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CountryFromJSON(jsonValue));
    }

    /**
     * Creates a new country with the provided details. Admin access required.
     * Create a new country
     */
    async createCountry(requestParameters: CreateCountryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Country> {
        const response = await this.createCountryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new country with the provided details. Admin access required.
     * Create a new country
     */
    async createCountry_1Raw(requestParameters: CreateCountry0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Country>> {
        if (requestParameters['createCountryDto'] == null) {
            throw new runtime.RequiredError(
                'createCountryDto',
                'Required parameter "createCountryDto" was null or undefined when calling createCountry_1().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/countries`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateCountryDtoToJSON(requestParameters['createCountryDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CountryFromJSON(jsonValue));
    }

    /**
     * Creates a new country with the provided details. Admin access required.
     * Create a new country
     */
    async createCountry_1(requestParameters: CreateCountry0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Country> {
        const response = await this.createCountry_1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new follow relationship between the authenticated user and another account
     * Create a new follow relationship
     */
    async createFollowRaw(requestParameters: CreateFollowOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Follow>> {
        if (requestParameters['createFollowRequest'] == null) {
            throw new runtime.RequiredError(
                'createFollowRequest',
                'Required parameter "createFollowRequest" was null or undefined when calling createFollow().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/follows`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateFollowRequestToJSON(requestParameters['createFollowRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FollowFromJSON(jsonValue));
    }

    /**
     * Creates a new follow relationship between the authenticated user and another account
     * Create a new follow relationship
     */
    async createFollow(requestParameters: CreateFollowOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Follow> {
        const response = await this.createFollowRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new follow relationship between the authenticated user and another account
     * Create a new follow relationship
     */
    async createFollow_2Raw(requestParameters: CreateFollow0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Follow>> {
        if (requestParameters['createFollowRequest'] == null) {
            throw new runtime.RequiredError(
                'createFollowRequest',
                'Required parameter "createFollowRequest" was null or undefined when calling createFollow_2().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/follows`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateFollowRequestToJSON(requestParameters['createFollowRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FollowFromJSON(jsonValue));
    }

    /**
     * Creates a new follow relationship between the authenticated user and another account
     * Create a new follow relationship
     */
    async createFollow_2(requestParameters: CreateFollow0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Follow> {
        const response = await this.createFollow_2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new itinerary with the provided details
     * Create a new itinerary
     */
    async createItineraryRaw(requestParameters: CreateItineraryOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Itinerary>> {
        if (requestParameters['createItineraryRequest'] == null) {
            throw new runtime.RequiredError(
                'createItineraryRequest',
                'Required parameter "createItineraryRequest" was null or undefined when calling createItinerary().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/itineraries`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateItineraryRequestToJSON(requestParameters['createItineraryRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ItineraryFromJSON(jsonValue));
    }

    /**
     * Creates a new itinerary with the provided details
     * Create a new itinerary
     */
    async createItinerary(requestParameters: CreateItineraryOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Itinerary> {
        const response = await this.createItineraryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new day in the specified itinerary
     * Create a new day in an itinerary
     */
    async createItineraryDayRaw(requestParameters: CreateItineraryDayRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Day>> {
        if (requestParameters['itineraryId'] == null) {
            throw new runtime.RequiredError(
                'itineraryId',
                'Required parameter "itineraryId" was null or undefined when calling createItineraryDay().'
            );
        }

        if (requestParameters['createDayDto'] == null) {
            throw new runtime.RequiredError(
                'createDayDto',
                'Required parameter "createDayDto" was null or undefined when calling createItineraryDay().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/itineraries/{itineraryId}/days`.replace(`{${"itineraryId"}}`, encodeURIComponent(String(requestParameters['itineraryId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateDayDtoToJSON(requestParameters['createDayDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DayFromJSON(jsonValue));
    }

    /**
     * Creates a new day in the specified itinerary
     * Create a new day in an itinerary
     */
    async createItineraryDay(requestParameters: CreateItineraryDayRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Day> {
        const response = await this.createItineraryDayRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new day in the specified itinerary
     * Create a new day in an itinerary
     */
    async createItineraryDay_3Raw(requestParameters: CreateItineraryDay0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Day>> {
        if (requestParameters['itineraryId'] == null) {
            throw new runtime.RequiredError(
                'itineraryId',
                'Required parameter "itineraryId" was null or undefined when calling createItineraryDay_3().'
            );
        }

        if (requestParameters['createDayDto'] == null) {
            throw new runtime.RequiredError(
                'createDayDto',
                'Required parameter "createDayDto" was null or undefined when calling createItineraryDay_3().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/itineraries/{itineraryId}/days`.replace(`{${"itineraryId"}}`, encodeURIComponent(String(requestParameters['itineraryId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateDayDtoToJSON(requestParameters['createDayDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DayFromJSON(jsonValue));
    }

    /**
     * Creates a new day in the specified itinerary
     * Create a new day in an itinerary
     */
    async createItineraryDay_3(requestParameters: CreateItineraryDay0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Day> {
        const response = await this.createItineraryDay_3Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new leg connecting two stops in an itinerary. Automatically calculates travel time and route using Mapbox unless disabled.
     * Create a new leg between two stops
     */
    async createLegRaw(requestParameters: CreateLegRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Leg>> {
        if (requestParameters['itineraryId'] == null) {
            throw new runtime.RequiredError(
                'itineraryId',
                'Required parameter "itineraryId" was null or undefined when calling createLeg().'
            );
        }

        if (requestParameters['createLegDto'] == null) {
            throw new runtime.RequiredError(
                'createLegDto',
                'Required parameter "createLegDto" was null or undefined when calling createLeg().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/itineraries/{itineraryId}/legs`.replace(`{${"itineraryId"}}`, encodeURIComponent(String(requestParameters['itineraryId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateLegDtoToJSON(requestParameters['createLegDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LegFromJSON(jsonValue));
    }

    /**
     * Creates a new leg connecting two stops in an itinerary. Automatically calculates travel time and route using Mapbox unless disabled.
     * Create a new leg between two stops
     */
    async createLeg(requestParameters: CreateLegRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Leg> {
        const response = await this.createLegRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new leg connecting two stops in an itinerary. Automatically calculates travel time and route using Mapbox unless disabled.
     * Create a new leg between two stops
     */
    async createLeg_4Raw(requestParameters: CreateLeg0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Leg>> {
        if (requestParameters['itineraryId'] == null) {
            throw new runtime.RequiredError(
                'itineraryId',
                'Required parameter "itineraryId" was null or undefined when calling createLeg_4().'
            );
        }

        if (requestParameters['createLegDto'] == null) {
            throw new runtime.RequiredError(
                'createLegDto',
                'Required parameter "createLegDto" was null or undefined when calling createLeg_4().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/itineraries/{itineraryId}/legs`.replace(`{${"itineraryId"}}`, encodeURIComponent(String(requestParameters['itineraryId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateLegDtoToJSON(requestParameters['createLegDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LegFromJSON(jsonValue));
    }

    /**
     * Creates a new leg connecting two stops in an itinerary. Automatically calculates travel time and route using Mapbox unless disabled.
     * Create a new leg between two stops
     */
    async createLeg_4(requestParameters: CreateLeg0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Leg> {
        const response = await this.createLeg_4Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a new conversation thread with the itinerary assistant. A new thread ID will be generated and returned in the response headers.
     * Create a new itinerary chat thread
     */
    async createNewChatRaw(requestParameters: CreateNewChatRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['sendMessageToThreadRequest'] == null) {
            throw new runtime.RequiredError(
                'sendMessageToThreadRequest',
                'Required parameter "sendMessageToThreadRequest" was null or undefined when calling createNewChat().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['itineraryId'] != null) {
            queryParameters['itineraryId'] = requestParameters['itineraryId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/chat`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SendMessageToThreadRequestToJSON(requestParameters['sendMessageToThreadRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Create a new conversation thread with the itinerary assistant. A new thread ID will be generated and returned in the response headers.
     * Create a new itinerary chat thread
     */
    async createNewChat(requestParameters: CreateNewChatRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createNewChatRaw(requestParameters, initOverrides);
    }

    /**
     * Creates a new order for the specified account. Uses Stripe for web, IAP for mobile.
     * Create a new order for credits
     */
    async createOrderRaw(requestParameters: CreateOrderOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Order>> {
        if (requestParameters['accountId'] == null) {
            throw new runtime.RequiredError(
                'accountId',
                'Required parameter "accountId" was null or undefined when calling createOrder().'
            );
        }

        if (requestParameters['createOrderRequest'] == null) {
            throw new runtime.RequiredError(
                'createOrderRequest',
                'Required parameter "createOrderRequest" was null or undefined when calling createOrder().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/accounts/{accountId}/orders`.replace(`{${"accountId"}}`, encodeURIComponent(String(requestParameters['accountId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateOrderRequestToJSON(requestParameters['createOrderRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrderFromJSON(jsonValue));
    }

    /**
     * Creates a new order for the specified account. Uses Stripe for web, IAP for mobile.
     * Create a new order for credits
     */
    async createOrder(requestParameters: CreateOrderOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Order> {
        const response = await this.createOrderRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new place with the provided details. Admin access required.
     * Create a new place
     */
    async createPlaceRaw(requestParameters: CreatePlaceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Place>> {
        if (requestParameters['createPlaceDto'] == null) {
            throw new runtime.RequiredError(
                'createPlaceDto',
                'Required parameter "createPlaceDto" was null or undefined when calling createPlace().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/places`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreatePlaceDtoToJSON(requestParameters['createPlaceDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PlaceFromJSON(jsonValue));
    }

    /**
     * Creates a new place with the provided details. Admin access required.
     * Create a new place
     */
    async createPlace(requestParameters: CreatePlaceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Place> {
        const response = await this.createPlaceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new place with the provided details. Admin access required.
     * Create a new place
     */
    async createPlace_5Raw(requestParameters: CreatePlace0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Place>> {
        if (requestParameters['createPlaceDto'] == null) {
            throw new runtime.RequiredError(
                'createPlaceDto',
                'Required parameter "createPlaceDto" was null or undefined when calling createPlace_5().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/places`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreatePlaceDtoToJSON(requestParameters['createPlaceDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PlaceFromJSON(jsonValue));
    }

    /**
     * Creates a new place with the provided details. Admin access required.
     * Create a new place
     */
    async createPlace_5(requestParameters: CreatePlace0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Place> {
        const response = await this.createPlace_5Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new post about an itinerary, stop, or other entity
     * Create a new post
     */
    async createPostRaw(requestParameters: CreatePostOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Post>> {
        if (requestParameters['createPostRequest'] == null) {
            throw new runtime.RequiredError(
                'createPostRequest',
                'Required parameter "createPostRequest" was null or undefined when calling createPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/posts`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreatePostRequestToJSON(requestParameters['createPostRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PostFromJSON(jsonValue));
    }

    /**
     * Creates a new post about an itinerary, stop, or other entity
     * Create a new post
     */
    async createPost(requestParameters: CreatePostOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Post> {
        const response = await this.createPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new post about an itinerary, stop, or other entity
     * Create a new post
     */
    async createPost_6Raw(requestParameters: CreatePost0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Post>> {
        if (requestParameters['createPostRequest'] == null) {
            throw new runtime.RequiredError(
                'createPostRequest',
                'Required parameter "createPostRequest" was null or undefined when calling createPost_6().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/posts`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreatePostRequestToJSON(requestParameters['createPostRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PostFromJSON(jsonValue));
    }

    /**
     * Creates a new post about an itinerary, stop, or other entity
     * Create a new post
     */
    async createPost_6(requestParameters: CreatePost0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Post> {
        const response = await this.createPost_6Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new like or dislike reaction for an itinerary or post
     * Create a new reaction
     */
    async createReactionRaw(requestParameters: CreateReactionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Reaction>> {
        if (requestParameters['createReactionRequest'] == null) {
            throw new runtime.RequiredError(
                'createReactionRequest',
                'Required parameter "createReactionRequest" was null or undefined when calling createReaction().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/reactions`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateReactionRequestToJSON(requestParameters['createReactionRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReactionFromJSON(jsonValue));
    }

    /**
     * Creates a new like or dislike reaction for an itinerary or post
     * Create a new reaction
     */
    async createReaction(requestParameters: CreateReactionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Reaction> {
        const response = await this.createReactionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new like or dislike reaction for an itinerary or post
     * Create a new reaction
     */
    async createReaction_7Raw(requestParameters: CreateReaction0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Reaction>> {
        if (requestParameters['createReactionRequest'] == null) {
            throw new runtime.RequiredError(
                'createReactionRequest',
                'Required parameter "createReactionRequest" was null or undefined when calling createReaction_7().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/reactions`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateReactionRequestToJSON(requestParameters['createReactionRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReactionFromJSON(jsonValue));
    }

    /**
     * Creates a new like or dislike reaction for an itinerary or post
     * Create a new reaction
     */
    async createReaction_7(requestParameters: CreateReaction0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Reaction> {
        const response = await this.createReaction_7Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new stop in the specified itinerary. Requires either a mapboxId for existing places, or location data to create a new place.
     * Create a new stop in an itinerary
     */
    async createStopRaw(requestParameters: CreateStopRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Stop>> {
        if (requestParameters['itineraryId'] == null) {
            throw new runtime.RequiredError(
                'itineraryId',
                'Required parameter "itineraryId" was null or undefined when calling createStop().'
            );
        }

        if (requestParameters['createStopDto'] == null) {
            throw new runtime.RequiredError(
                'createStopDto',
                'Required parameter "createStopDto" was null or undefined when calling createStop().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/itineraries/{itineraryId}/stops`.replace(`{${"itineraryId"}}`, encodeURIComponent(String(requestParameters['itineraryId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateStopDtoToJSON(requestParameters['createStopDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StopFromJSON(jsonValue));
    }

    /**
     * Creates a new stop in the specified itinerary. Requires either a mapboxId for existing places, or location data to create a new place.
     * Create a new stop in an itinerary
     */
    async createStop(requestParameters: CreateStopRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Stop> {
        const response = await this.createStopRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new stop in the specified itinerary. Requires either a mapboxId for existing places, or location data to create a new place.
     * Create a new stop in an itinerary
     */
    async createStop_8Raw(requestParameters: CreateStop0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Stop>> {
        if (requestParameters['itineraryId'] == null) {
            throw new runtime.RequiredError(
                'itineraryId',
                'Required parameter "itineraryId" was null or undefined when calling createStop_8().'
            );
        }

        if (requestParameters['createStopDto'] == null) {
            throw new runtime.RequiredError(
                'createStopDto',
                'Required parameter "createStopDto" was null or undefined when calling createStop_8().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/itineraries/{itineraryId}/stops`.replace(`{${"itineraryId"}}`, encodeURIComponent(String(requestParameters['itineraryId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateStopDtoToJSON(requestParameters['createStopDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StopFromJSON(jsonValue));
    }

    /**
     * Creates a new stop in the specified itinerary. Requires either a mapboxId for existing places, or location data to create a new place.
     * Create a new stop in an itinerary
     */
    async createStop_8(requestParameters: CreateStop0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Stop> {
        const response = await this.createStop_8Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deletes a stop from the itinerary and reorders remaining stops in affected days
     * Delete a stop
     */
    async deleteStopRaw(requestParameters: DeleteStopRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['itineraryId'] == null) {
            throw new runtime.RequiredError(
                'itineraryId',
                'Required parameter "itineraryId" was null or undefined when calling deleteStop().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteStop().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/itineraries/{itineraryId}/stops/{id}`.replace(`{${"itineraryId"}}`, encodeURIComponent(String(requestParameters['itineraryId']))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes a stop from the itinerary and reorders remaining stops in affected days
     * Delete a stop
     */
    async deleteStop(requestParameters: DeleteStopRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteStopRaw(requestParameters, initOverrides);
    }

    /**
     * Deletes a stop from the itinerary and reorders remaining stops in affected days
     * Delete a stop
     */
    async deleteStop_9Raw(requestParameters: DeleteStop0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['itineraryId'] == null) {
            throw new runtime.RequiredError(
                'itineraryId',
                'Required parameter "itineraryId" was null or undefined when calling deleteStop_9().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteStop_9().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/itineraries/{itineraryId}/stops/{id}`.replace(`{${"itineraryId"}}`, encodeURIComponent(String(requestParameters['itineraryId']))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes a stop from the itinerary and reorders remaining stops in affected days
     * Delete a stop
     */
    async deleteStop_9(requestParameters: DeleteStop0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteStop_9Raw(requestParameters, initOverrides);
    }

    /**
     * Get all records
     */
    async findAllAccountRaw(requestParameters: FindAllAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Account>>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        if (requestParameters['ids'] != null) {
            queryParameters['ids'] = requestParameters['ids'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/accounts`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AccountFromJSON));
    }

    /**
     * Get all records
     */
    async findAllAccount(requestParameters: FindAllAccountRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Account>> {
        const response = await this.findAllAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all records
     */
    async findAllAccountChatRaw(requestParameters: FindAllAccountChatRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Chat>>> {
        if (requestParameters['accountId'] == null) {
            throw new runtime.RequiredError(
                'accountId',
                'Required parameter "accountId" was null or undefined when calling findAllAccountChat().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        if (requestParameters['ids'] != null) {
            queryParameters['ids'] = requestParameters['ids'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/accounts/{accountId}/chats`.replace(`{${"accountId"}}`, encodeURIComponent(String(requestParameters['accountId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ChatFromJSON));
    }

    /**
     * Get all records
     */
    async findAllAccountChat(requestParameters: FindAllAccountChatRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Chat>> {
        const response = await this.findAllAccountChatRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all records
     */
    async findAllCountryRaw(requestParameters: FindAllCountryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Country>>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        if (requestParameters['ids'] != null) {
            queryParameters['ids'] = requestParameters['ids'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/countries`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CountryFromJSON));
    }

    /**
     * Get all records
     */
    async findAllCountry(requestParameters: FindAllCountryRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Country>> {
        const response = await this.findAllCountryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all records
     */
    async findAllCountry_10Raw(requestParameters: FindAllCountry0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Country>>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        if (requestParameters['ids'] != null) {
            queryParameters['ids'] = requestParameters['ids'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/countries`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CountryFromJSON));
    }

    /**
     * Get all records
     */
    async findAllCountry_10(requestParameters: FindAllCountry0Request = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Country>> {
        const response = await this.findAllCountry_10Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all records
     */
    async findAllFollowRaw(requestParameters: FindAllFollowRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Follow>>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        if (requestParameters['ids'] != null) {
            queryParameters['ids'] = requestParameters['ids'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/follows`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(FollowFromJSON));
    }

    /**
     * Get all records
     */
    async findAllFollow(requestParameters: FindAllFollowRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Follow>> {
        const response = await this.findAllFollowRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all records
     */
    async findAllFollow_11Raw(requestParameters: FindAllFollow0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Follow>>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        if (requestParameters['ids'] != null) {
            queryParameters['ids'] = requestParameters['ids'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/follows`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(FollowFromJSON));
    }

    /**
     * Get all records
     */
    async findAllFollow_11(requestParameters: FindAllFollow0Request = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Follow>> {
        const response = await this.findAllFollow_11Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all records
     */
    async findAllItineraryRaw(requestParameters: FindAllItineraryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Itinerary>>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        if (requestParameters['ids'] != null) {
            queryParameters['ids'] = requestParameters['ids'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/itineraries`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ItineraryFromJSON));
    }

    /**
     * Get all records
     */
    async findAllItinerary(requestParameters: FindAllItineraryRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Itinerary>> {
        const response = await this.findAllItineraryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all records
     */
    async findAllItineraryDayRaw(requestParameters: FindAllItineraryDayRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Day>>> {
        if (requestParameters['itineraryId'] == null) {
            throw new runtime.RequiredError(
                'itineraryId',
                'Required parameter "itineraryId" was null or undefined when calling findAllItineraryDay().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        if (requestParameters['ids'] != null) {
            queryParameters['ids'] = requestParameters['ids'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/itineraries/{itineraryId}/days`.replace(`{${"itineraryId"}}`, encodeURIComponent(String(requestParameters['itineraryId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DayFromJSON));
    }

    /**
     * Get all records
     */
    async findAllItineraryDay(requestParameters: FindAllItineraryDayRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Day>> {
        const response = await this.findAllItineraryDayRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all records
     */
    async findAllItineraryDay_12Raw(requestParameters: FindAllItineraryDay0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Day>>> {
        if (requestParameters['itineraryId'] == null) {
            throw new runtime.RequiredError(
                'itineraryId',
                'Required parameter "itineraryId" was null or undefined when calling findAllItineraryDay_12().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        if (requestParameters['ids'] != null) {
            queryParameters['ids'] = requestParameters['ids'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/itineraries/{itineraryId}/days`.replace(`{${"itineraryId"}}`, encodeURIComponent(String(requestParameters['itineraryId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DayFromJSON));
    }

    /**
     * Get all records
     */
    async findAllItineraryDay_12(requestParameters: FindAllItineraryDay0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Day>> {
        const response = await this.findAllItineraryDay_12Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all records
     */
    async findAllItineraryLegRaw(requestParameters: FindAllItineraryLegRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Leg>>> {
        if (requestParameters['itineraryId'] == null) {
            throw new runtime.RequiredError(
                'itineraryId',
                'Required parameter "itineraryId" was null or undefined when calling findAllItineraryLeg().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        if (requestParameters['ids'] != null) {
            queryParameters['ids'] = requestParameters['ids'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/itineraries/{itineraryId}/legs`.replace(`{${"itineraryId"}}`, encodeURIComponent(String(requestParameters['itineraryId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(LegFromJSON));
    }

    /**
     * Get all records
     */
    async findAllItineraryLeg(requestParameters: FindAllItineraryLegRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Leg>> {
        const response = await this.findAllItineraryLegRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all records
     */
    async findAllItineraryLeg_13Raw(requestParameters: FindAllItineraryLeg0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Leg>>> {
        if (requestParameters['itineraryId'] == null) {
            throw new runtime.RequiredError(
                'itineraryId',
                'Required parameter "itineraryId" was null or undefined when calling findAllItineraryLeg_13().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        if (requestParameters['ids'] != null) {
            queryParameters['ids'] = requestParameters['ids'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/itineraries/{itineraryId}/legs`.replace(`{${"itineraryId"}}`, encodeURIComponent(String(requestParameters['itineraryId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(LegFromJSON));
    }

    /**
     * Get all records
     */
    async findAllItineraryLeg_13(requestParameters: FindAllItineraryLeg0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Leg>> {
        const response = await this.findAllItineraryLeg_13Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns all public itineraries with optimized projection fields for entry page. Results are cached for 1 minute.
     * Get all public itinerary projections
     */
    async findAllItineraryProjectionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ItineraryProjection>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/itinerary-projections`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ItineraryProjectionFromJSON));
    }

    /**
     * Returns all public itineraries with optimized projection fields for entry page. Results are cached for 1 minute.
     * Get all public itinerary projections
     */
    async findAllItineraryProjections(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ItineraryProjection>> {
        const response = await this.findAllItineraryProjectionsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get all records
     */
    async findAllItineraryStopRaw(requestParameters: FindAllItineraryStopRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Stop>>> {
        if (requestParameters['itineraryId'] == null) {
            throw new runtime.RequiredError(
                'itineraryId',
                'Required parameter "itineraryId" was null or undefined when calling findAllItineraryStop().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        if (requestParameters['ids'] != null) {
            queryParameters['ids'] = requestParameters['ids'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/itineraries/{itineraryId}/stops`.replace(`{${"itineraryId"}}`, encodeURIComponent(String(requestParameters['itineraryId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(StopFromJSON));
    }

    /**
     * Get all records
     */
    async findAllItineraryStop(requestParameters: FindAllItineraryStopRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Stop>> {
        const response = await this.findAllItineraryStopRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all records
     */
    async findAllItineraryStop_14Raw(requestParameters: FindAllItineraryStop0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Stop>>> {
        if (requestParameters['itineraryId'] == null) {
            throw new runtime.RequiredError(
                'itineraryId',
                'Required parameter "itineraryId" was null or undefined when calling findAllItineraryStop_14().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        if (requestParameters['ids'] != null) {
            queryParameters['ids'] = requestParameters['ids'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/itineraries/{itineraryId}/stops`.replace(`{${"itineraryId"}}`, encodeURIComponent(String(requestParameters['itineraryId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(StopFromJSON));
    }

    /**
     * Get all records
     */
    async findAllItineraryStop_14(requestParameters: FindAllItineraryStop0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Stop>> {
        const response = await this.findAllItineraryStop_14Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all records
     */
    async findAllPlaceRaw(requestParameters: FindAllPlaceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Place>>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        if (requestParameters['ids'] != null) {
            queryParameters['ids'] = requestParameters['ids'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/places`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PlaceFromJSON));
    }

    /**
     * Get all records
     */
    async findAllPlace(requestParameters: FindAllPlaceRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Place>> {
        const response = await this.findAllPlaceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all records
     */
    async findAllPlace_15Raw(requestParameters: FindAllPlace0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Place>>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        if (requestParameters['ids'] != null) {
            queryParameters['ids'] = requestParameters['ids'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/places`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PlaceFromJSON));
    }

    /**
     * Get all records
     */
    async findAllPlace_15(requestParameters: FindAllPlace0Request = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Place>> {
        const response = await this.findAllPlace_15Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all records
     */
    async findAllPostRaw(requestParameters: FindAllPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Post>>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        if (requestParameters['ids'] != null) {
            queryParameters['ids'] = requestParameters['ids'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/posts`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PostFromJSON));
    }

    /**
     * Get all records
     */
    async findAllPost(requestParameters: FindAllPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Post>> {
        const response = await this.findAllPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all records
     */
    async findAllPost_16Raw(requestParameters: FindAllPost0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Post>>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        if (requestParameters['ids'] != null) {
            queryParameters['ids'] = requestParameters['ids'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/posts`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PostFromJSON));
    }

    /**
     * Get all records
     */
    async findAllPost_16(requestParameters: FindAllPost0Request = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Post>> {
        const response = await this.findAllPost_16Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all records
     */
    async findAllReactionRaw(requestParameters: FindAllReactionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Reaction>>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        if (requestParameters['ids'] != null) {
            queryParameters['ids'] = requestParameters['ids'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/reactions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ReactionFromJSON));
    }

    /**
     * Get all records
     */
    async findAllReaction(requestParameters: FindAllReactionRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Reaction>> {
        const response = await this.findAllReactionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all records
     */
    async findAllReaction_17Raw(requestParameters: FindAllReaction0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Reaction>>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        if (requestParameters['ids'] != null) {
            queryParameters['ids'] = requestParameters['ids'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/reactions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ReactionFromJSON));
    }

    /**
     * Get all records
     */
    async findAllReaction_17(requestParameters: FindAllReaction0Request = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Reaction>> {
        const response = await this.findAllReaction_17Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all records
     */
    async findAllStopRaw(requestParameters: FindAllStopRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Stop>>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        if (requestParameters['ids'] != null) {
            queryParameters['ids'] = requestParameters['ids'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/stops`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(StopFromJSON));
    }

    /**
     * Get all records
     */
    async findAllStop(requestParameters: FindAllStopRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Stop>> {
        const response = await this.findAllStopRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns all accepted stops from public itineraries with optimized place projection fields for entry page. Only stops in ACCEPTED state are included. Results are cached for 1 minute.
     * Get all public accepted stop projections
     */
    async findAllStopProjectionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<StopProjection>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/stop-projections`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(StopProjectionFromJSON));
    }

    /**
     * Returns all accepted stops from public itineraries with optimized place projection fields for entry page. Only stops in ACCEPTED state are included. Results are cached for 1 minute.
     * Get all public accepted stop projections
     */
    async findAllStopProjections(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<StopProjection>> {
        const response = await this.findAllStopProjectionsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get all records
     */
    async findAllStop_18Raw(requestParameters: FindAllStop0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Stop>>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        if (requestParameters['ids'] != null) {
            queryParameters['ids'] = requestParameters['ids'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/stops`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(StopFromJSON));
    }

    /**
     * Get all records
     */
    async findAllStop_18(requestParameters: FindAllStop0Request = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Stop>> {
        const response = await this.findAllStop_18Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get one record
     */
    async findOneAccountRaw(requestParameters: FindOneAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Account>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling findOneAccount().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/accounts/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AccountFromJSON(jsonValue));
    }

    /**
     * Get one record
     */
    async findOneAccount(requestParameters: FindOneAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Account> {
        const response = await this.findOneAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get one record
     */
    async findOneAccountChatRaw(requestParameters: FindOneAccountChatRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Chat>> {
        if (requestParameters['accountId'] == null) {
            throw new runtime.RequiredError(
                'accountId',
                'Required parameter "accountId" was null or undefined when calling findOneAccountChat().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling findOneAccountChat().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/accounts/{accountId}/chats/{id}`.replace(`{${"accountId"}}`, encodeURIComponent(String(requestParameters['accountId']))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChatFromJSON(jsonValue));
    }

    /**
     * Get one record
     */
    async findOneAccountChat(requestParameters: FindOneAccountChatRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Chat> {
        const response = await this.findOneAccountChatRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get one record
     */
    async findOneCountryRaw(requestParameters: FindOneCountryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Country>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling findOneCountry().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/countries/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CountryFromJSON(jsonValue));
    }

    /**
     * Get one record
     */
    async findOneCountry(requestParameters: FindOneCountryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Country> {
        const response = await this.findOneCountryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get one record
     */
    async findOneCountry_19Raw(requestParameters: FindOneCountry0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Country>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling findOneCountry_19().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/countries/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CountryFromJSON(jsonValue));
    }

    /**
     * Get one record
     */
    async findOneCountry_19(requestParameters: FindOneCountry0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Country> {
        const response = await this.findOneCountry_19Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get one record
     */
    async findOneFollowRaw(requestParameters: FindOneFollowRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Follow>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling findOneFollow().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/follows/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FollowFromJSON(jsonValue));
    }

    /**
     * Get one record
     */
    async findOneFollow(requestParameters: FindOneFollowRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Follow> {
        const response = await this.findOneFollowRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get one record
     */
    async findOneFollow_20Raw(requestParameters: FindOneFollow0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Follow>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling findOneFollow_20().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/follows/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FollowFromJSON(jsonValue));
    }

    /**
     * Get one record
     */
    async findOneFollow_20(requestParameters: FindOneFollow0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Follow> {
        const response = await this.findOneFollow_20Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get one record
     */
    async findOneItineraryRaw(requestParameters: FindOneItineraryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Itinerary>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling findOneItinerary().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/itineraries/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ItineraryFromJSON(jsonValue));
    }

    /**
     * Get one record
     */
    async findOneItinerary(requestParameters: FindOneItineraryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Itinerary> {
        const response = await this.findOneItineraryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get one record
     */
    async findOneItineraryDayRaw(requestParameters: FindOneItineraryDayRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Day>> {
        if (requestParameters['itineraryId'] == null) {
            throw new runtime.RequiredError(
                'itineraryId',
                'Required parameter "itineraryId" was null or undefined when calling findOneItineraryDay().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling findOneItineraryDay().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/itineraries/{itineraryId}/days/{id}`.replace(`{${"itineraryId"}}`, encodeURIComponent(String(requestParameters['itineraryId']))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DayFromJSON(jsonValue));
    }

    /**
     * Get one record
     */
    async findOneItineraryDay(requestParameters: FindOneItineraryDayRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Day> {
        const response = await this.findOneItineraryDayRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get one record
     */
    async findOneItineraryDay_21Raw(requestParameters: FindOneItineraryDay0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Day>> {
        if (requestParameters['itineraryId'] == null) {
            throw new runtime.RequiredError(
                'itineraryId',
                'Required parameter "itineraryId" was null or undefined when calling findOneItineraryDay_21().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling findOneItineraryDay_21().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/itineraries/{itineraryId}/days/{id}`.replace(`{${"itineraryId"}}`, encodeURIComponent(String(requestParameters['itineraryId']))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DayFromJSON(jsonValue));
    }

    /**
     * Get one record
     */
    async findOneItineraryDay_21(requestParameters: FindOneItineraryDay0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Day> {
        const response = await this.findOneItineraryDay_21Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get one record
     */
    async findOneItineraryLegRaw(requestParameters: FindOneItineraryLegRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Leg>> {
        if (requestParameters['itineraryId'] == null) {
            throw new runtime.RequiredError(
                'itineraryId',
                'Required parameter "itineraryId" was null or undefined when calling findOneItineraryLeg().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling findOneItineraryLeg().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/itineraries/{itineraryId}/legs/{id}`.replace(`{${"itineraryId"}}`, encodeURIComponent(String(requestParameters['itineraryId']))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LegFromJSON(jsonValue));
    }

    /**
     * Get one record
     */
    async findOneItineraryLeg(requestParameters: FindOneItineraryLegRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Leg> {
        const response = await this.findOneItineraryLegRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get one record
     */
    async findOneItineraryLeg_22Raw(requestParameters: FindOneItineraryLeg0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Leg>> {
        if (requestParameters['itineraryId'] == null) {
            throw new runtime.RequiredError(
                'itineraryId',
                'Required parameter "itineraryId" was null or undefined when calling findOneItineraryLeg_22().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling findOneItineraryLeg_22().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/itineraries/{itineraryId}/legs/{id}`.replace(`{${"itineraryId"}}`, encodeURIComponent(String(requestParameters['itineraryId']))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LegFromJSON(jsonValue));
    }

    /**
     * Get one record
     */
    async findOneItineraryLeg_22(requestParameters: FindOneItineraryLeg0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Leg> {
        const response = await this.findOneItineraryLeg_22Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get one record
     */
    async findOneItineraryStopRaw(requestParameters: FindOneItineraryStopRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Stop>> {
        if (requestParameters['itineraryId'] == null) {
            throw new runtime.RequiredError(
                'itineraryId',
                'Required parameter "itineraryId" was null or undefined when calling findOneItineraryStop().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling findOneItineraryStop().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/itineraries/{itineraryId}/stops/{id}`.replace(`{${"itineraryId"}}`, encodeURIComponent(String(requestParameters['itineraryId']))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StopFromJSON(jsonValue));
    }

    /**
     * Get one record
     */
    async findOneItineraryStop(requestParameters: FindOneItineraryStopRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Stop> {
        const response = await this.findOneItineraryStopRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get one record
     */
    async findOneItineraryStop_23Raw(requestParameters: FindOneItineraryStop0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Stop>> {
        if (requestParameters['itineraryId'] == null) {
            throw new runtime.RequiredError(
                'itineraryId',
                'Required parameter "itineraryId" was null or undefined when calling findOneItineraryStop_23().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling findOneItineraryStop_23().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/itineraries/{itineraryId}/stops/{id}`.replace(`{${"itineraryId"}}`, encodeURIComponent(String(requestParameters['itineraryId']))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StopFromJSON(jsonValue));
    }

    /**
     * Get one record
     */
    async findOneItineraryStop_23(requestParameters: FindOneItineraryStop0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Stop> {
        const response = await this.findOneItineraryStop_23Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get one record
     */
    async findOnePlaceRaw(requestParameters: FindOnePlaceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Place>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling findOnePlace().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/places/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PlaceFromJSON(jsonValue));
    }

    /**
     * Get one record
     */
    async findOnePlace(requestParameters: FindOnePlaceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Place> {
        const response = await this.findOnePlaceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get one record
     */
    async findOnePlace_24Raw(requestParameters: FindOnePlace0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Place>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling findOnePlace_24().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/places/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PlaceFromJSON(jsonValue));
    }

    /**
     * Get one record
     */
    async findOnePlace_24(requestParameters: FindOnePlace0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Place> {
        const response = await this.findOnePlace_24Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get one record
     */
    async findOnePostRaw(requestParameters: FindOnePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Post>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling findOnePost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/posts/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PostFromJSON(jsonValue));
    }

    /**
     * Get one record
     */
    async findOnePost(requestParameters: FindOnePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Post> {
        const response = await this.findOnePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get one record
     */
    async findOnePost_25Raw(requestParameters: FindOnePost0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Post>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling findOnePost_25().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/posts/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PostFromJSON(jsonValue));
    }

    /**
     * Get one record
     */
    async findOnePost_25(requestParameters: FindOnePost0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Post> {
        const response = await this.findOnePost_25Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get one record
     */
    async findOneReactionRaw(requestParameters: FindOneReactionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Reaction>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling findOneReaction().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/reactions/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReactionFromJSON(jsonValue));
    }

    /**
     * Get one record
     */
    async findOneReaction(requestParameters: FindOneReactionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Reaction> {
        const response = await this.findOneReactionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get one record
     */
    async findOneReaction_26Raw(requestParameters: FindOneReaction0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Reaction>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling findOneReaction_26().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/reactions/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReactionFromJSON(jsonValue));
    }

    /**
     * Get one record
     */
    async findOneReaction_26(requestParameters: FindOneReaction0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Reaction> {
        const response = await this.findOneReaction_26Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get one record
     */
    async findOneStopRaw(requestParameters: FindOneStopRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Stop>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling findOneStop().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/stops/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StopFromJSON(jsonValue));
    }

    /**
     * Get one record
     */
    async findOneStop(requestParameters: FindOneStopRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Stop> {
        const response = await this.findOneStopRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get one record
     */
    async findOneStop_27Raw(requestParameters: FindOneStop0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Stop>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling findOneStop_27().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/stops/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StopFromJSON(jsonValue));
    }

    /**
     * Get one record
     */
    async findOneStop_27(requestParameters: FindOneStop0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Stop> {
        const response = await this.findOneStop_27Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Generate a temporary SAS token for direct client-side upload to Azure Blob Storage
     * Generate SAS token for direct Azure upload
     */
    async generateSASTokenRaw(requestParameters: GenerateSASTokenOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GenerateSASToken201Response>> {
        if (requestParameters['generateSASTokenRequest'] == null) {
            throw new runtime.RequiredError(
                'generateSASTokenRequest',
                'Required parameter "generateSASTokenRequest" was null or undefined when calling generateSASToken().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/files/sas-token`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GenerateSASTokenRequestToJSON(requestParameters['generateSASTokenRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GenerateSASToken201ResponseFromJSON(jsonValue));
    }

    /**
     * Generate a temporary SAS token for direct client-side upload to Azure Blob Storage
     * Generate SAS token for direct Azure upload
     */
    async generateSASToken(requestParameters: GenerateSASTokenOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GenerateSASToken201Response> {
        const response = await this.generateSASTokenRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns the chat history for a specific thread ID from the checkpoint system in Vercel AI SDK format. This includes conversations about itinerary planning, creation, and modification.
     * Get itinerary chat history for a thread
     */
    async getChatHistoryRaw(requestParameters: GetChatHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetChatHistory200ResponseInner>>> {
        if (requestParameters['threadId'] == null) {
            throw new runtime.RequiredError(
                'threadId',
                'Required parameter "threadId" was null or undefined when calling getChatHistory().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['itineraryId'] != null) {
            queryParameters['itineraryId'] = requestParameters['itineraryId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/chat/{threadId}`.replace(`{${"threadId"}}`, encodeURIComponent(String(requestParameters['threadId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetChatHistory200ResponseInnerFromJSON));
    }

    /**
     * Returns the chat history for a specific thread ID from the checkpoint system in Vercel AI SDK format. This includes conversations about itinerary planning, creation, and modification.
     * Get itinerary chat history for a thread
     */
    async getChatHistory(requestParameters: GetChatHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetChatHistory200ResponseInner>> {
        const response = await this.getChatHistoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns all available credit packages for purchase
     * Get available credit packages
     */
    async getCreditPackagesRaw(requestParameters: GetCreditPackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CreditPackage>>> {
        if (requestParameters['accountId'] == null) {
            throw new runtime.RequiredError(
                'accountId',
                'Required parameter "accountId" was null or undefined when calling getCreditPackages().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/accounts/{accountId}/orders/packages`.replace(`{${"accountId"}}`, encodeURIComponent(String(requestParameters['accountId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CreditPackageFromJSON));
    }

    /**
     * Returns all available credit packages for purchase
     * Get available credit packages
     */
    async getCreditPackages(requestParameters: GetCreditPackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CreditPackage>> {
        const response = await this.getCreditPackagesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns all itineraries that have at least one stop within the specified geographical boundaries
     * Get itineraries by geographical boundaries
     */
    async getItinerariesByBoundsRaw(requestParameters: GetItinerariesByBoundsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Itinerary>>> {
        if (requestParameters['southWestLng'] == null) {
            throw new runtime.RequiredError(
                'southWestLng',
                'Required parameter "southWestLng" was null or undefined when calling getItinerariesByBounds().'
            );
        }

        if (requestParameters['southWestLat'] == null) {
            throw new runtime.RequiredError(
                'southWestLat',
                'Required parameter "southWestLat" was null or undefined when calling getItinerariesByBounds().'
            );
        }

        if (requestParameters['northEastLng'] == null) {
            throw new runtime.RequiredError(
                'northEastLng',
                'Required parameter "northEastLng" was null or undefined when calling getItinerariesByBounds().'
            );
        }

        if (requestParameters['northEastLat'] == null) {
            throw new runtime.RequiredError(
                'northEastLat',
                'Required parameter "northEastLat" was null or undefined when calling getItinerariesByBounds().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['southWestLng'] != null) {
            queryParameters['southWestLng'] = requestParameters['southWestLng'];
        }

        if (requestParameters['southWestLat'] != null) {
            queryParameters['southWestLat'] = requestParameters['southWestLat'];
        }

        if (requestParameters['northEastLng'] != null) {
            queryParameters['northEastLng'] = requestParameters['northEastLng'];
        }

        if (requestParameters['northEastLat'] != null) {
            queryParameters['northEastLat'] = requestParameters['northEastLat'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/itineraries/by-bounds`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ItineraryFromJSON));
    }

    /**
     * Returns all itineraries that have at least one stop within the specified geographical boundaries
     * Get itineraries by geographical boundaries
     */
    async getItinerariesByBounds(requestParameters: GetItinerariesByBoundsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Itinerary>> {
        const response = await this.getItinerariesByBoundsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get the current user\'s Account
     */
    async getMyAccountRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Account>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/accounts/me`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AccountFromJSON(jsonValue));
    }

    /**
     * Get the current user\'s Account
     */
    async getMyAccount(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Account> {
        const response = await this.getMyAccountRaw(initOverrides);
        return await response.value();
    }

    /**
     * Returns details for a specific order by ID
     * Get a specific order
     */
    async getOrderRaw(requestParameters: GetOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Order>> {
        if (requestParameters['accountId'] == null) {
            throw new runtime.RequiredError(
                'accountId',
                'Required parameter "accountId" was null or undefined when calling getOrder().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getOrder().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/accounts/{accountId}/orders/{id}`.replace(`{${"accountId"}}`, encodeURIComponent(String(requestParameters['accountId']))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrderFromJSON(jsonValue));
    }

    /**
     * Returns details for a specific order by ID
     * Get a specific order
     */
    async getOrder(requestParameters: GetOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Order> {
        const response = await this.getOrderRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns all orders associated with the specified account
     * Get all orders for an account
     */
    async getOrdersRaw(requestParameters: GetOrdersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Order>>> {
        if (requestParameters['accountId'] == null) {
            throw new runtime.RequiredError(
                'accountId',
                'Required parameter "accountId" was null or undefined when calling getOrders().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/accounts/{accountId}/orders`.replace(`{${"accountId"}}`, encodeURIComponent(String(requestParameters['accountId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OrderFromJSON));
    }

    /**
     * Returns all orders associated with the specified account
     * Get all orders for an account
     */
    async getOrders(requestParameters: GetOrdersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Order>> {
        const response = await this.getOrdersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete record
     */
    async removeAccountRaw(requestParameters: RemoveAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling removeAccount().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/accounts/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete record
     */
    async removeAccount(requestParameters: RemoveAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.removeAccountRaw(requestParameters, initOverrides);
    }

    /**
     * Delete record
     */
    async removeCountryRaw(requestParameters: RemoveCountryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling removeCountry().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/countries/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete record
     */
    async removeCountry(requestParameters: RemoveCountryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.removeCountryRaw(requestParameters, initOverrides);
    }

    /**
     * Delete record
     */
    async removeCountry_28Raw(requestParameters: RemoveCountry0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling removeCountry_28().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/countries/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete record
     */
    async removeCountry_28(requestParameters: RemoveCountry0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.removeCountry_28Raw(requestParameters, initOverrides);
    }

    /**
     * Delete record
     */
    async removeDayRaw(requestParameters: RemoveDayRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['itineraryId'] == null) {
            throw new runtime.RequiredError(
                'itineraryId',
                'Required parameter "itineraryId" was null or undefined when calling removeDay().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling removeDay().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/itineraries/{itineraryId}/days/{id}`.replace(`{${"itineraryId"}}`, encodeURIComponent(String(requestParameters['itineraryId']))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete record
     */
    async removeDay(requestParameters: RemoveDayRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.removeDayRaw(requestParameters, initOverrides);
    }

    /**
     * Delete record
     */
    async removeDay_29Raw(requestParameters: RemoveDay0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['itineraryId'] == null) {
            throw new runtime.RequiredError(
                'itineraryId',
                'Required parameter "itineraryId" was null or undefined when calling removeDay_29().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling removeDay_29().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/itineraries/{itineraryId}/days/{id}`.replace(`{${"itineraryId"}}`, encodeURIComponent(String(requestParameters['itineraryId']))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete record
     */
    async removeDay_29(requestParameters: RemoveDay0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.removeDay_29Raw(requestParameters, initOverrides);
    }

    /**
     * Removes a follow relationship between the authenticated user and another account
     * Remove a follow relationship
     */
    async removeFollowRaw(requestParameters: RemoveFollowRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['followingId'] == null) {
            throw new runtime.RequiredError(
                'followingId',
                'Required parameter "followingId" was null or undefined when calling removeFollow().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/follows/{followingId}`.replace(`{${"followingId"}}`, encodeURIComponent(String(requestParameters['followingId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Removes a follow relationship between the authenticated user and another account
     * Remove a follow relationship
     */
    async removeFollow(requestParameters: RemoveFollowRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.removeFollowRaw(requestParameters, initOverrides);
    }

    /**
     * Removes a follow relationship between the authenticated user and another account
     * Remove a follow relationship
     */
    async removeFollow_30Raw(requestParameters: RemoveFollow0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['followingId'] == null) {
            throw new runtime.RequiredError(
                'followingId',
                'Required parameter "followingId" was null or undefined when calling removeFollow_30().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/follows/{followingId}`.replace(`{${"followingId"}}`, encodeURIComponent(String(requestParameters['followingId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Removes a follow relationship between the authenticated user and another account
     * Remove a follow relationship
     */
    async removeFollow_30(requestParameters: RemoveFollow0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.removeFollow_30Raw(requestParameters, initOverrides);
    }

    /**
     * Delete record
     */
    async removeItineraryRaw(requestParameters: RemoveItineraryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling removeItinerary().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/itineraries/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete record
     */
    async removeItinerary(requestParameters: RemoveItineraryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.removeItineraryRaw(requestParameters, initOverrides);
    }

    /**
     * Delete record
     */
    async removeLegRaw(requestParameters: RemoveLegRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['itineraryId'] == null) {
            throw new runtime.RequiredError(
                'itineraryId',
                'Required parameter "itineraryId" was null or undefined when calling removeLeg().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling removeLeg().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/itineraries/{itineraryId}/legs/{id}`.replace(`{${"itineraryId"}}`, encodeURIComponent(String(requestParameters['itineraryId']))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete record
     */
    async removeLeg(requestParameters: RemoveLegRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.removeLegRaw(requestParameters, initOverrides);
    }

    /**
     * Delete record
     */
    async removeLeg_31Raw(requestParameters: RemoveLeg0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['itineraryId'] == null) {
            throw new runtime.RequiredError(
                'itineraryId',
                'Required parameter "itineraryId" was null or undefined when calling removeLeg_31().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling removeLeg_31().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/itineraries/{itineraryId}/legs/{id}`.replace(`{${"itineraryId"}}`, encodeURIComponent(String(requestParameters['itineraryId']))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete record
     */
    async removeLeg_31(requestParameters: RemoveLeg0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.removeLeg_31Raw(requestParameters, initOverrides);
    }

    /**
     * Delete multiple records
     */
    async removeManyAccountsRaw(requestParameters: RemoveManyAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['filter'] == null) {
            throw new runtime.RequiredError(
                'filter',
                'Required parameter "filter" was null or undefined when calling removeManyAccounts().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/accounts`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete multiple records
     */
    async removeManyAccounts(requestParameters: RemoveManyAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.removeManyAccountsRaw(requestParameters, initOverrides);
    }

    /**
     * Delete multiple records
     */
    async removeManyCountrysRaw(requestParameters: RemoveManyCountrysRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['filter'] == null) {
            throw new runtime.RequiredError(
                'filter',
                'Required parameter "filter" was null or undefined when calling removeManyCountrys().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/countries`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete multiple records
     */
    async removeManyCountrys(requestParameters: RemoveManyCountrysRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.removeManyCountrysRaw(requestParameters, initOverrides);
    }

    /**
     * Delete multiple records
     */
    async removeManyCountrys_32Raw(requestParameters: RemoveManyCountrys0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['filter'] == null) {
            throw new runtime.RequiredError(
                'filter',
                'Required parameter "filter" was null or undefined when calling removeManyCountrys_32().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/countries`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete multiple records
     */
    async removeManyCountrys_32(requestParameters: RemoveManyCountrys0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.removeManyCountrys_32Raw(requestParameters, initOverrides);
    }

    /**
     * Delete multiple records
     */
    async removeManyDaysRaw(requestParameters: RemoveManyDaysRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['itineraryId'] == null) {
            throw new runtime.RequiredError(
                'itineraryId',
                'Required parameter "itineraryId" was null or undefined when calling removeManyDays().'
            );
        }

        if (requestParameters['filter'] == null) {
            throw new runtime.RequiredError(
                'filter',
                'Required parameter "filter" was null or undefined when calling removeManyDays().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/itineraries/{itineraryId}/days`.replace(`{${"itineraryId"}}`, encodeURIComponent(String(requestParameters['itineraryId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete multiple records
     */
    async removeManyDays(requestParameters: RemoveManyDaysRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.removeManyDaysRaw(requestParameters, initOverrides);
    }

    /**
     * Delete multiple records
     */
    async removeManyDays_33Raw(requestParameters: RemoveManyDays0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['itineraryId'] == null) {
            throw new runtime.RequiredError(
                'itineraryId',
                'Required parameter "itineraryId" was null or undefined when calling removeManyDays_33().'
            );
        }

        if (requestParameters['filter'] == null) {
            throw new runtime.RequiredError(
                'filter',
                'Required parameter "filter" was null or undefined when calling removeManyDays_33().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/itineraries/{itineraryId}/days`.replace(`{${"itineraryId"}}`, encodeURIComponent(String(requestParameters['itineraryId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete multiple records
     */
    async removeManyDays_33(requestParameters: RemoveManyDays0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.removeManyDays_33Raw(requestParameters, initOverrides);
    }

    /**
     * Delete multiple records
     */
    async removeManyFollowsRaw(requestParameters: RemoveManyFollowsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['filter'] == null) {
            throw new runtime.RequiredError(
                'filter',
                'Required parameter "filter" was null or undefined when calling removeManyFollows().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/follows`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete multiple records
     */
    async removeManyFollows(requestParameters: RemoveManyFollowsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.removeManyFollowsRaw(requestParameters, initOverrides);
    }

    /**
     * Delete multiple records
     */
    async removeManyFollows_34Raw(requestParameters: RemoveManyFollows0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['filter'] == null) {
            throw new runtime.RequiredError(
                'filter',
                'Required parameter "filter" was null or undefined when calling removeManyFollows_34().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/follows`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete multiple records
     */
    async removeManyFollows_34(requestParameters: RemoveManyFollows0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.removeManyFollows_34Raw(requestParameters, initOverrides);
    }

    /**
     * Delete multiple records
     */
    async removeManyItinerarysRaw(requestParameters: RemoveManyItinerarysRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['filter'] == null) {
            throw new runtime.RequiredError(
                'filter',
                'Required parameter "filter" was null or undefined when calling removeManyItinerarys().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/itineraries`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete multiple records
     */
    async removeManyItinerarys(requestParameters: RemoveManyItinerarysRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.removeManyItinerarysRaw(requestParameters, initOverrides);
    }

    /**
     * Delete multiple records
     */
    async removeManyLegsRaw(requestParameters: RemoveManyLegsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['itineraryId'] == null) {
            throw new runtime.RequiredError(
                'itineraryId',
                'Required parameter "itineraryId" was null or undefined when calling removeManyLegs().'
            );
        }

        if (requestParameters['filter'] == null) {
            throw new runtime.RequiredError(
                'filter',
                'Required parameter "filter" was null or undefined when calling removeManyLegs().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/itineraries/{itineraryId}/legs`.replace(`{${"itineraryId"}}`, encodeURIComponent(String(requestParameters['itineraryId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete multiple records
     */
    async removeManyLegs(requestParameters: RemoveManyLegsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.removeManyLegsRaw(requestParameters, initOverrides);
    }

    /**
     * Delete multiple records
     */
    async removeManyLegs_35Raw(requestParameters: RemoveManyLegs0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['itineraryId'] == null) {
            throw new runtime.RequiredError(
                'itineraryId',
                'Required parameter "itineraryId" was null or undefined when calling removeManyLegs_35().'
            );
        }

        if (requestParameters['filter'] == null) {
            throw new runtime.RequiredError(
                'filter',
                'Required parameter "filter" was null or undefined when calling removeManyLegs_35().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/itineraries/{itineraryId}/legs`.replace(`{${"itineraryId"}}`, encodeURIComponent(String(requestParameters['itineraryId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete multiple records
     */
    async removeManyLegs_35(requestParameters: RemoveManyLegs0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.removeManyLegs_35Raw(requestParameters, initOverrides);
    }

    /**
     * Delete multiple records
     */
    async removeManyPlacesRaw(requestParameters: RemoveManyPlacesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['filter'] == null) {
            throw new runtime.RequiredError(
                'filter',
                'Required parameter "filter" was null or undefined when calling removeManyPlaces().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/places`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete multiple records
     */
    async removeManyPlaces(requestParameters: RemoveManyPlacesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.removeManyPlacesRaw(requestParameters, initOverrides);
    }

    /**
     * Delete multiple records
     */
    async removeManyPlaces_36Raw(requestParameters: RemoveManyPlaces0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['filter'] == null) {
            throw new runtime.RequiredError(
                'filter',
                'Required parameter "filter" was null or undefined when calling removeManyPlaces_36().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/places`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete multiple records
     */
    async removeManyPlaces_36(requestParameters: RemoveManyPlaces0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.removeManyPlaces_36Raw(requestParameters, initOverrides);
    }

    /**
     * Delete multiple records
     */
    async removeManyPostsRaw(requestParameters: RemoveManyPostsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['filter'] == null) {
            throw new runtime.RequiredError(
                'filter',
                'Required parameter "filter" was null or undefined when calling removeManyPosts().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/posts`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete multiple records
     */
    async removeManyPosts(requestParameters: RemoveManyPostsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.removeManyPostsRaw(requestParameters, initOverrides);
    }

    /**
     * Delete multiple records
     */
    async removeManyPosts_37Raw(requestParameters: RemoveManyPosts0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['filter'] == null) {
            throw new runtime.RequiredError(
                'filter',
                'Required parameter "filter" was null or undefined when calling removeManyPosts_37().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/posts`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete multiple records
     */
    async removeManyPosts_37(requestParameters: RemoveManyPosts0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.removeManyPosts_37Raw(requestParameters, initOverrides);
    }

    /**
     * Delete multiple records
     */
    async removeManyReactionsRaw(requestParameters: RemoveManyReactionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['filter'] == null) {
            throw new runtime.RequiredError(
                'filter',
                'Required parameter "filter" was null or undefined when calling removeManyReactions().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/reactions`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete multiple records
     */
    async removeManyReactions(requestParameters: RemoveManyReactionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.removeManyReactionsRaw(requestParameters, initOverrides);
    }

    /**
     * Delete multiple records
     */
    async removeManyReactions_38Raw(requestParameters: RemoveManyReactions0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['filter'] == null) {
            throw new runtime.RequiredError(
                'filter',
                'Required parameter "filter" was null or undefined when calling removeManyReactions_38().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/reactions`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete multiple records
     */
    async removeManyReactions_38(requestParameters: RemoveManyReactions0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.removeManyReactions_38Raw(requestParameters, initOverrides);
    }

    /**
     * Delete record
     */
    async removePlaceRaw(requestParameters: RemovePlaceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling removePlace().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/places/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete record
     */
    async removePlace(requestParameters: RemovePlaceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.removePlaceRaw(requestParameters, initOverrides);
    }

    /**
     * Delete record
     */
    async removePlace_39Raw(requestParameters: RemovePlace0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling removePlace_39().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/places/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete record
     */
    async removePlace_39(requestParameters: RemovePlace0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.removePlace_39Raw(requestParameters, initOverrides);
    }

    /**
     * Delete record
     */
    async removePostRaw(requestParameters: RemovePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling removePost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/posts/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete record
     */
    async removePost(requestParameters: RemovePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.removePostRaw(requestParameters, initOverrides);
    }

    /**
     * Delete record
     */
    async removePost_40Raw(requestParameters: RemovePost0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling removePost_40().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/posts/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete record
     */
    async removePost_40(requestParameters: RemovePost0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.removePost_40Raw(requestParameters, initOverrides);
    }

    /**
     * Removes a specific reaction for an itinerary or post
     * Remove a reaction
     */
    async removeReactionRaw(requestParameters: RemoveReactionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['reactableType'] == null) {
            throw new runtime.RequiredError(
                'reactableType',
                'Required parameter "reactableType" was null or undefined when calling removeReaction().'
            );
        }

        if (requestParameters['reactableId'] == null) {
            throw new runtime.RequiredError(
                'reactableId',
                'Required parameter "reactableId" was null or undefined when calling removeReaction().'
            );
        }

        if (requestParameters['reactionType'] == null) {
            throw new runtime.RequiredError(
                'reactionType',
                'Required parameter "reactionType" was null or undefined when calling removeReaction().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/reactions/{reactableType}/{reactableId}/{reactionType}`.replace(`{${"reactableType"}}`, encodeURIComponent(String(requestParameters['reactableType']))).replace(`{${"reactableId"}}`, encodeURIComponent(String(requestParameters['reactableId']))).replace(`{${"reactionType"}}`, encodeURIComponent(String(requestParameters['reactionType']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Removes a specific reaction for an itinerary or post
     * Remove a reaction
     */
    async removeReaction(requestParameters: RemoveReactionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.removeReactionRaw(requestParameters, initOverrides);
    }

    /**
     * Removes a specific reaction for an itinerary or post
     * Remove a reaction
     */
    async removeReaction_41Raw(requestParameters: RemoveReaction0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['reactableType'] == null) {
            throw new runtime.RequiredError(
                'reactableType',
                'Required parameter "reactableType" was null or undefined when calling removeReaction_41().'
            );
        }

        if (requestParameters['reactableId'] == null) {
            throw new runtime.RequiredError(
                'reactableId',
                'Required parameter "reactableId" was null or undefined when calling removeReaction_41().'
            );
        }

        if (requestParameters['reactionType'] == null) {
            throw new runtime.RequiredError(
                'reactionType',
                'Required parameter "reactionType" was null or undefined when calling removeReaction_41().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/reactions/{reactableType}/{reactableId}/{reactionType}`.replace(`{${"reactableType"}}`, encodeURIComponent(String(requestParameters['reactableType']))).replace(`{${"reactableId"}}`, encodeURIComponent(String(requestParameters['reactableId']))).replace(`{${"reactionType"}}`, encodeURIComponent(String(requestParameters['reactionType']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Removes a specific reaction for an itinerary or post
     * Remove a reaction
     */
    async removeReaction_41(requestParameters: RemoveReaction0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.removeReaction_41Raw(requestParameters, initOverrides);
    }

    /**
     * Search for accounts using natural language queries. Supports fuzzy matching by default for better user experience.
     * Search accounts by username
     */
    async searchAccountsRaw(requestParameters: SearchAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchAccounts200Response>> {
        if (requestParameters['q'] == null) {
            throw new runtime.RequiredError(
                'q',
                'Required parameter "q" was null or undefined when calling searchAccounts().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['q'] != null) {
            queryParameters['q'] = requestParameters['q'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['minScore'] != null) {
            queryParameters['minScore'] = requestParameters['minScore'];
        }

        if (requestParameters['fuzzyMatch'] != null) {
            queryParameters['fuzzyMatch'] = requestParameters['fuzzyMatch'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/accounts/search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchAccounts200ResponseFromJSON(jsonValue));
    }

    /**
     * Search for accounts using natural language queries. Supports fuzzy matching by default for better user experience.
     * Search accounts by username
     */
    async searchAccounts(requestParameters: SearchAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchAccounts200Response> {
        const response = await this.searchAccountsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search for preview images based on search term and save them to database for selection
     * Search and save preview images by word
     */
    async searchAndSavePreviewImagesByWordRaw(requestParameters: SearchAndSavePreviewImagesByWordOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Image>>> {
        if (requestParameters['searchAndSavePreviewImagesByWordRequest'] == null) {
            throw new runtime.RequiredError(
                'searchAndSavePreviewImagesByWordRequest',
                'Required parameter "searchAndSavePreviewImagesByWordRequest" was null or undefined when calling searchAndSavePreviewImagesByWord().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/itineraries/preview-images`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SearchAndSavePreviewImagesByWordRequestToJSON(requestParameters['searchAndSavePreviewImagesByWordRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ImageFromJSON));
    }

    /**
     * Search for preview images based on search term and save them to database for selection
     * Search and save preview images by word
     */
    async searchAndSavePreviewImagesByWord(requestParameters: SearchAndSavePreviewImagesByWordOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Image>> {
        const response = await this.searchAndSavePreviewImagesByWordRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search for preview images related to a specific itinerary and save them to database for selection
     * Search and save preview images for an itinerary
     */
    async searchAndSavePreviewImagesForItineraryRaw(requestParameters: SearchAndSavePreviewImagesForItineraryOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Image>>> {
        if (requestParameters['itineraryId'] == null) {
            throw new runtime.RequiredError(
                'itineraryId',
                'Required parameter "itineraryId" was null or undefined when calling searchAndSavePreviewImagesForItinerary().'
            );
        }

        if (requestParameters['searchAndSavePreviewImagesForItineraryRequest'] == null) {
            throw new runtime.RequiredError(
                'searchAndSavePreviewImagesForItineraryRequest',
                'Required parameter "searchAndSavePreviewImagesForItineraryRequest" was null or undefined when calling searchAndSavePreviewImagesForItinerary().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/itineraries/{itineraryId}/preview-images`.replace(`{${"itineraryId"}}`, encodeURIComponent(String(requestParameters['itineraryId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SearchAndSavePreviewImagesForItineraryRequestToJSON(requestParameters['searchAndSavePreviewImagesForItineraryRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ImageFromJSON));
    }

    /**
     * Search for preview images related to a specific itinerary and save them to database for selection
     * Search and save preview images for an itinerary
     */
    async searchAndSavePreviewImagesForItinerary(requestParameters: SearchAndSavePreviewImagesForItineraryOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Image>> {
        const response = await this.searchAndSavePreviewImagesForItineraryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search for preview images related to a stop location and save them to database for selection
     * Search and save preview images for a stop location
     */
    async searchAndSavePreviewImagesForStopRaw(requestParameters: SearchAndSavePreviewImagesForStopOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Image>>> {
        if (requestParameters['itineraryId'] == null) {
            throw new runtime.RequiredError(
                'itineraryId',
                'Required parameter "itineraryId" was null or undefined when calling searchAndSavePreviewImagesForStop().'
            );
        }

        if (requestParameters['searchAndSavePreviewImagesForStopRequest'] == null) {
            throw new runtime.RequiredError(
                'searchAndSavePreviewImagesForStopRequest',
                'Required parameter "searchAndSavePreviewImagesForStopRequest" was null or undefined when calling searchAndSavePreviewImagesForStop().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/itineraries/{itineraryId}/stops/preview-images`.replace(`{${"itineraryId"}}`, encodeURIComponent(String(requestParameters['itineraryId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SearchAndSavePreviewImagesForStopRequestToJSON(requestParameters['searchAndSavePreviewImagesForStopRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ImageFromJSON));
    }

    /**
     * Search for preview images related to a stop location and save them to database for selection
     * Search and save preview images for a stop location
     */
    async searchAndSavePreviewImagesForStop(requestParameters: SearchAndSavePreviewImagesForStopOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Image>> {
        const response = await this.searchAndSavePreviewImagesForStopRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search for preview images related to a stop location and save them to database for selection
     * Search and save preview images for a stop location
     */
    async searchAndSavePreviewImagesForStop_42Raw(requestParameters: SearchAndSavePreviewImagesForStop0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Image>>> {
        if (requestParameters['itineraryId'] == null) {
            throw new runtime.RequiredError(
                'itineraryId',
                'Required parameter "itineraryId" was null or undefined when calling searchAndSavePreviewImagesForStop_42().'
            );
        }

        if (requestParameters['searchAndSavePreviewImagesForStopRequest'] == null) {
            throw new runtime.RequiredError(
                'searchAndSavePreviewImagesForStopRequest',
                'Required parameter "searchAndSavePreviewImagesForStopRequest" was null or undefined when calling searchAndSavePreviewImagesForStop_42().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/itineraries/{itineraryId}/stops/preview-images`.replace(`{${"itineraryId"}}`, encodeURIComponent(String(requestParameters['itineraryId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SearchAndSavePreviewImagesForStopRequestToJSON(requestParameters['searchAndSavePreviewImagesForStopRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ImageFromJSON));
    }

    /**
     * Search for preview images related to a stop location and save them to database for selection
     * Search and save preview images for a stop location
     */
    async searchAndSavePreviewImagesForStop_42(requestParameters: SearchAndSavePreviewImagesForStop0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Image>> {
        const response = await this.searchAndSavePreviewImagesForStop_42Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search through itineraries using natural language queries. Searches across title, description, highlights, and other searchable fields with fuzzy matching by default for optimal user experience. Includes relevance scoring and result highlighting.
     * Search itineraries using natural language queries
     */
    async searchItinerariesRaw(requestParameters: SearchItinerariesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchItineraries200Response>> {
        if (requestParameters['q'] == null) {
            throw new runtime.RequiredError(
                'q',
                'Required parameter "q" was null or undefined when calling searchItineraries().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['q'] != null) {
            queryParameters['q'] = requestParameters['q'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['minScore'] != null) {
            queryParameters['minScore'] = requestParameters['minScore'];
        }

        if (requestParameters['fuzzyMatch'] != null) {
            queryParameters['fuzzyMatch'] = requestParameters['fuzzyMatch'];
        }

        if (requestParameters['visibility'] != null) {
            queryParameters['visibility'] = requestParameters['visibility'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/itineraries/search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchItineraries200ResponseFromJSON(jsonValue));
    }

    /**
     * Search through itineraries using natural language queries. Searches across title, description, highlights, and other searchable fields with fuzzy matching by default for optimal user experience. Includes relevance scoring and result highlighting.
     * Search itineraries using natural language queries
     */
    async searchItineraries(requestParameters: SearchItinerariesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchItineraries200Response> {
        const response = await this.searchItinerariesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search through stops using natural language queries with location awareness. Searches across stop titles, descriptions, highlights, city names, country names, and place names. Perfect for finding stops in specific locations like \"Paris\" or \"France\".
     * Search stops using natural language queries
     */
    async searchStopsRaw(requestParameters: SearchStopsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchStops200Response>> {
        if (requestParameters['q'] == null) {
            throw new runtime.RequiredError(
                'q',
                'Required parameter "q" was null or undefined when calling searchStops().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['q'] != null) {
            queryParameters['q'] = requestParameters['q'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['minScore'] != null) {
            queryParameters['minScore'] = requestParameters['minScore'];
        }

        if (requestParameters['fuzzyMatch'] != null) {
            queryParameters['fuzzyMatch'] = requestParameters['fuzzyMatch'];
        }

        if (requestParameters['country'] != null) {
            queryParameters['country'] = requestParameters['country'];
        }

        if (requestParameters['city'] != null) {
            queryParameters['city'] = requestParameters['city'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/itineraries/stops/search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchStops200ResponseFromJSON(jsonValue));
    }

    /**
     * Search through stops using natural language queries with location awareness. Searches across stop titles, descriptions, highlights, city names, country names, and place names. Perfect for finding stops in specific locations like \"Paris\" or \"France\".
     * Search stops using natural language queries
     */
    async searchStops(requestParameters: SearchStopsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchStops200Response> {
        const response = await this.searchStopsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Send a message to an existing conversation thread with the itinerary assistant. The response is streamed in real-time using Vercel AI SDK format.
     * Send a message to an existing itinerary chat thread
     */
    async sendMessageToThreadRaw(requestParameters: SendMessageToThreadOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling sendMessageToThread().'
            );
        }

        if (requestParameters['sendMessageToThreadRequest'] == null) {
            throw new runtime.RequiredError(
                'sendMessageToThreadRequest',
                'Required parameter "sendMessageToThreadRequest" was null or undefined when calling sendMessageToThread().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['itineraryId'] != null) {
            queryParameters['itineraryId'] = requestParameters['itineraryId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/chat/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SendMessageToThreadRequestToJSON(requestParameters['sendMessageToThreadRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Send a message to an existing conversation thread with the itinerary assistant. The response is streamed in real-time using Vercel AI SDK format.
     * Send a message to an existing itinerary chat thread
     */
    async sendMessageToThread(requestParameters: SendMessageToThreadOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.sendMessageToThreadRaw(requestParameters, initOverrides);
    }

    /**
     * Update an Account username
     */
    async updateAccountRaw(requestParameters: UpdateAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Account>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateAccount().'
            );
        }

        if (requestParameters['updateAccountDto'] == null) {
            throw new runtime.RequiredError(
                'updateAccountDto',
                'Required parameter "updateAccountDto" was null or undefined when calling updateAccount().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/accounts/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateAccountDtoToJSON(requestParameters['updateAccountDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AccountFromJSON(jsonValue));
    }

    /**
     * Update an Account username
     */
    async updateAccount(requestParameters: UpdateAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Account> {
        const response = await this.updateAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update record
     */
    async updateCountryRaw(requestParameters: UpdateCountryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Country>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateCountry().'
            );
        }

        if (requestParameters['country'] == null) {
            throw new runtime.RequiredError(
                'country',
                'Required parameter "country" was null or undefined when calling updateCountry().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/countries/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: CountryToJSON(requestParameters['country']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CountryFromJSON(jsonValue));
    }

    /**
     * Update record
     */
    async updateCountry(requestParameters: UpdateCountryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Country> {
        const response = await this.updateCountryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update record
     */
    async updateCountry_43Raw(requestParameters: UpdateCountry0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Country>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateCountry_43().'
            );
        }

        if (requestParameters['country'] == null) {
            throw new runtime.RequiredError(
                'country',
                'Required parameter "country" was null or undefined when calling updateCountry_43().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/countries/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: CountryToJSON(requestParameters['country']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CountryFromJSON(jsonValue));
    }

    /**
     * Update record
     */
    async updateCountry_43(requestParameters: UpdateCountry0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Country> {
        const response = await this.updateCountry_43Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates a day and its associated stops
     * Update a day
     */
    async updateDayRaw(requestParameters: UpdateDayOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Day>> {
        if (requestParameters['itineraryId'] == null) {
            throw new runtime.RequiredError(
                'itineraryId',
                'Required parameter "itineraryId" was null or undefined when calling updateDay().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateDay().'
            );
        }

        if (requestParameters['updateDayRequest'] == null) {
            throw new runtime.RequiredError(
                'updateDayRequest',
                'Required parameter "updateDayRequest" was null or undefined when calling updateDay().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/itineraries/{itineraryId}/days/{id}`.replace(`{${"itineraryId"}}`, encodeURIComponent(String(requestParameters['itineraryId']))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateDayRequestToJSON(requestParameters['updateDayRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DayFromJSON(jsonValue));
    }

    /**
     * Updates a day and its associated stops
     * Update a day
     */
    async updateDay(requestParameters: UpdateDayOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Day> {
        const response = await this.updateDayRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates a day and its associated stops
     * Update a day
     */
    async updateDay_44Raw(requestParameters: UpdateDay0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Day>> {
        if (requestParameters['itineraryId'] == null) {
            throw new runtime.RequiredError(
                'itineraryId',
                'Required parameter "itineraryId" was null or undefined when calling updateDay_44().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateDay_44().'
            );
        }

        if (requestParameters['updateDayRequest'] == null) {
            throw new runtime.RequiredError(
                'updateDayRequest',
                'Required parameter "updateDayRequest" was null or undefined when calling updateDay_44().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/itineraries/{itineraryId}/days/{id}`.replace(`{${"itineraryId"}}`, encodeURIComponent(String(requestParameters['itineraryId']))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateDayRequestToJSON(requestParameters['updateDayRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DayFromJSON(jsonValue));
    }

    /**
     * Updates a day and its associated stops
     * Update a day
     */
    async updateDay_44(requestParameters: UpdateDay0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Day> {
        const response = await this.updateDay_44Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update record
     */
    async updateFollowRaw(requestParameters: UpdateFollowRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Follow>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateFollow().'
            );
        }

        if (requestParameters['follow'] == null) {
            throw new runtime.RequiredError(
                'follow',
                'Required parameter "follow" was null or undefined when calling updateFollow().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/follows/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: FollowToJSON(requestParameters['follow']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FollowFromJSON(jsonValue));
    }

    /**
     * Update record
     */
    async updateFollow(requestParameters: UpdateFollowRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Follow> {
        const response = await this.updateFollowRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update record
     */
    async updateFollow_45Raw(requestParameters: UpdateFollow0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Follow>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateFollow_45().'
            );
        }

        if (requestParameters['follow'] == null) {
            throw new runtime.RequiredError(
                'follow',
                'Required parameter "follow" was null or undefined when calling updateFollow_45().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/follows/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: FollowToJSON(requestParameters['follow']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FollowFromJSON(jsonValue));
    }

    /**
     * Update record
     */
    async updateFollow_45(requestParameters: UpdateFollow0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Follow> {
        const response = await this.updateFollow_45Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update record
     */
    async updateItineraryRaw(requestParameters: UpdateItineraryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Itinerary>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateItinerary().'
            );
        }

        if (requestParameters['itinerary'] == null) {
            throw new runtime.RequiredError(
                'itinerary',
                'Required parameter "itinerary" was null or undefined when calling updateItinerary().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/itineraries/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: ItineraryToJSON(requestParameters['itinerary']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ItineraryFromJSON(jsonValue));
    }

    /**
     * Update record
     */
    async updateItinerary(requestParameters: UpdateItineraryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Itinerary> {
        const response = await this.updateItineraryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates a leg between two stops. If travel mode is changed, automatically recalculates travel time and route using Mapbox unless disabled.
     * Update a leg
     */
    async updateLegRaw(requestParameters: UpdateLegOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Leg>> {
        if (requestParameters['itineraryId'] == null) {
            throw new runtime.RequiredError(
                'itineraryId',
                'Required parameter "itineraryId" was null or undefined when calling updateLeg().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateLeg().'
            );
        }

        if (requestParameters['updateLegRequest'] == null) {
            throw new runtime.RequiredError(
                'updateLegRequest',
                'Required parameter "updateLegRequest" was null or undefined when calling updateLeg().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/itineraries/{itineraryId}/legs/{id}`.replace(`{${"itineraryId"}}`, encodeURIComponent(String(requestParameters['itineraryId']))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateLegRequestToJSON(requestParameters['updateLegRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LegFromJSON(jsonValue));
    }

    /**
     * Updates a leg between two stops. If travel mode is changed, automatically recalculates travel time and route using Mapbox unless disabled.
     * Update a leg
     */
    async updateLeg(requestParameters: UpdateLegOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Leg> {
        const response = await this.updateLegRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates a leg between two stops. If travel mode is changed, automatically recalculates travel time and route using Mapbox unless disabled.
     * Update a leg
     */
    async updateLeg_46Raw(requestParameters: UpdateLeg0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Leg>> {
        if (requestParameters['itineraryId'] == null) {
            throw new runtime.RequiredError(
                'itineraryId',
                'Required parameter "itineraryId" was null or undefined when calling updateLeg_46().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateLeg_46().'
            );
        }

        if (requestParameters['updateLegRequest'] == null) {
            throw new runtime.RequiredError(
                'updateLegRequest',
                'Required parameter "updateLegRequest" was null or undefined when calling updateLeg_46().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/itineraries/{itineraryId}/legs/{id}`.replace(`{${"itineraryId"}}`, encodeURIComponent(String(requestParameters['itineraryId']))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateLegRequestToJSON(requestParameters['updateLegRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LegFromJSON(jsonValue));
    }

    /**
     * Updates a leg between two stops. If travel mode is changed, automatically recalculates travel time and route using Mapbox unless disabled.
     * Update a leg
     */
    async updateLeg_46(requestParameters: UpdateLeg0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Leg> {
        const response = await this.updateLeg_46Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update multiple records
     */
    async updateManyAccountsRaw(requestParameters: UpdateManyAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['filter'] == null) {
            throw new runtime.RequiredError(
                'filter',
                'Required parameter "filter" was null or undefined when calling updateManyAccounts().'
            );
        }

        if (requestParameters['account'] == null) {
            throw new runtime.RequiredError(
                'account',
                'Required parameter "account" was null or undefined when calling updateManyAccounts().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/accounts`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: AccountToJSON(requestParameters['account']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update multiple records
     */
    async updateManyAccounts(requestParameters: UpdateManyAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateManyAccountsRaw(requestParameters, initOverrides);
    }

    /**
     * Update multiple records
     */
    async updateManyCountrysRaw(requestParameters: UpdateManyCountrysRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['filter'] == null) {
            throw new runtime.RequiredError(
                'filter',
                'Required parameter "filter" was null or undefined when calling updateManyCountrys().'
            );
        }

        if (requestParameters['country'] == null) {
            throw new runtime.RequiredError(
                'country',
                'Required parameter "country" was null or undefined when calling updateManyCountrys().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/countries`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: CountryToJSON(requestParameters['country']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update multiple records
     */
    async updateManyCountrys(requestParameters: UpdateManyCountrysRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateManyCountrysRaw(requestParameters, initOverrides);
    }

    /**
     * Update multiple records
     */
    async updateManyCountrys_47Raw(requestParameters: UpdateManyCountrys0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['filter'] == null) {
            throw new runtime.RequiredError(
                'filter',
                'Required parameter "filter" was null or undefined when calling updateManyCountrys_47().'
            );
        }

        if (requestParameters['country'] == null) {
            throw new runtime.RequiredError(
                'country',
                'Required parameter "country" was null or undefined when calling updateManyCountrys_47().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/countries`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: CountryToJSON(requestParameters['country']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update multiple records
     */
    async updateManyCountrys_47(requestParameters: UpdateManyCountrys0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateManyCountrys_47Raw(requestParameters, initOverrides);
    }

    /**
     * Update multiple records
     */
    async updateManyDaysRaw(requestParameters: UpdateManyDaysRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['itineraryId'] == null) {
            throw new runtime.RequiredError(
                'itineraryId',
                'Required parameter "itineraryId" was null or undefined when calling updateManyDays().'
            );
        }

        if (requestParameters['filter'] == null) {
            throw new runtime.RequiredError(
                'filter',
                'Required parameter "filter" was null or undefined when calling updateManyDays().'
            );
        }

        if (requestParameters['day'] == null) {
            throw new runtime.RequiredError(
                'day',
                'Required parameter "day" was null or undefined when calling updateManyDays().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/itineraries/{itineraryId}/days`.replace(`{${"itineraryId"}}`, encodeURIComponent(String(requestParameters['itineraryId']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: DayToJSON(requestParameters['day']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update multiple records
     */
    async updateManyDays(requestParameters: UpdateManyDaysRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateManyDaysRaw(requestParameters, initOverrides);
    }

    /**
     * Update multiple records
     */
    async updateManyDays_48Raw(requestParameters: UpdateManyDays0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['itineraryId'] == null) {
            throw new runtime.RequiredError(
                'itineraryId',
                'Required parameter "itineraryId" was null or undefined when calling updateManyDays_48().'
            );
        }

        if (requestParameters['filter'] == null) {
            throw new runtime.RequiredError(
                'filter',
                'Required parameter "filter" was null or undefined when calling updateManyDays_48().'
            );
        }

        if (requestParameters['day'] == null) {
            throw new runtime.RequiredError(
                'day',
                'Required parameter "day" was null or undefined when calling updateManyDays_48().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/itineraries/{itineraryId}/days`.replace(`{${"itineraryId"}}`, encodeURIComponent(String(requestParameters['itineraryId']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: DayToJSON(requestParameters['day']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update multiple records
     */
    async updateManyDays_48(requestParameters: UpdateManyDays0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateManyDays_48Raw(requestParameters, initOverrides);
    }

    /**
     * Update multiple records
     */
    async updateManyFollowsRaw(requestParameters: UpdateManyFollowsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['filter'] == null) {
            throw new runtime.RequiredError(
                'filter',
                'Required parameter "filter" was null or undefined when calling updateManyFollows().'
            );
        }

        if (requestParameters['follow'] == null) {
            throw new runtime.RequiredError(
                'follow',
                'Required parameter "follow" was null or undefined when calling updateManyFollows().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/follows`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: FollowToJSON(requestParameters['follow']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update multiple records
     */
    async updateManyFollows(requestParameters: UpdateManyFollowsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateManyFollowsRaw(requestParameters, initOverrides);
    }

    /**
     * Update multiple records
     */
    async updateManyFollows_49Raw(requestParameters: UpdateManyFollows0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['filter'] == null) {
            throw new runtime.RequiredError(
                'filter',
                'Required parameter "filter" was null or undefined when calling updateManyFollows_49().'
            );
        }

        if (requestParameters['follow'] == null) {
            throw new runtime.RequiredError(
                'follow',
                'Required parameter "follow" was null or undefined when calling updateManyFollows_49().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/follows`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: FollowToJSON(requestParameters['follow']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update multiple records
     */
    async updateManyFollows_49(requestParameters: UpdateManyFollows0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateManyFollows_49Raw(requestParameters, initOverrides);
    }

    /**
     * Update multiple records
     */
    async updateManyItinerarysRaw(requestParameters: UpdateManyItinerarysRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['filter'] == null) {
            throw new runtime.RequiredError(
                'filter',
                'Required parameter "filter" was null or undefined when calling updateManyItinerarys().'
            );
        }

        if (requestParameters['itinerary'] == null) {
            throw new runtime.RequiredError(
                'itinerary',
                'Required parameter "itinerary" was null or undefined when calling updateManyItinerarys().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/itineraries`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: ItineraryToJSON(requestParameters['itinerary']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update multiple records
     */
    async updateManyItinerarys(requestParameters: UpdateManyItinerarysRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateManyItinerarysRaw(requestParameters, initOverrides);
    }

    /**
     * Update multiple records
     */
    async updateManyLegsRaw(requestParameters: UpdateManyLegsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['itineraryId'] == null) {
            throw new runtime.RequiredError(
                'itineraryId',
                'Required parameter "itineraryId" was null or undefined when calling updateManyLegs().'
            );
        }

        if (requestParameters['filter'] == null) {
            throw new runtime.RequiredError(
                'filter',
                'Required parameter "filter" was null or undefined when calling updateManyLegs().'
            );
        }

        if (requestParameters['leg'] == null) {
            throw new runtime.RequiredError(
                'leg',
                'Required parameter "leg" was null or undefined when calling updateManyLegs().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/itineraries/{itineraryId}/legs`.replace(`{${"itineraryId"}}`, encodeURIComponent(String(requestParameters['itineraryId']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: LegToJSON(requestParameters['leg']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update multiple records
     */
    async updateManyLegs(requestParameters: UpdateManyLegsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateManyLegsRaw(requestParameters, initOverrides);
    }

    /**
     * Update multiple records
     */
    async updateManyLegs_50Raw(requestParameters: UpdateManyLegs0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['itineraryId'] == null) {
            throw new runtime.RequiredError(
                'itineraryId',
                'Required parameter "itineraryId" was null or undefined when calling updateManyLegs_50().'
            );
        }

        if (requestParameters['filter'] == null) {
            throw new runtime.RequiredError(
                'filter',
                'Required parameter "filter" was null or undefined when calling updateManyLegs_50().'
            );
        }

        if (requestParameters['leg'] == null) {
            throw new runtime.RequiredError(
                'leg',
                'Required parameter "leg" was null or undefined when calling updateManyLegs_50().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/itineraries/{itineraryId}/legs`.replace(`{${"itineraryId"}}`, encodeURIComponent(String(requestParameters['itineraryId']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: LegToJSON(requestParameters['leg']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update multiple records
     */
    async updateManyLegs_50(requestParameters: UpdateManyLegs0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateManyLegs_50Raw(requestParameters, initOverrides);
    }

    /**
     * Update multiple records
     */
    async updateManyPlacesRaw(requestParameters: UpdateManyPlacesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['filter'] == null) {
            throw new runtime.RequiredError(
                'filter',
                'Required parameter "filter" was null or undefined when calling updateManyPlaces().'
            );
        }

        if (requestParameters['place'] == null) {
            throw new runtime.RequiredError(
                'place',
                'Required parameter "place" was null or undefined when calling updateManyPlaces().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/places`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PlaceToJSON(requestParameters['place']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update multiple records
     */
    async updateManyPlaces(requestParameters: UpdateManyPlacesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateManyPlacesRaw(requestParameters, initOverrides);
    }

    /**
     * Update multiple records
     */
    async updateManyPlaces_51Raw(requestParameters: UpdateManyPlaces0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['filter'] == null) {
            throw new runtime.RequiredError(
                'filter',
                'Required parameter "filter" was null or undefined when calling updateManyPlaces_51().'
            );
        }

        if (requestParameters['place'] == null) {
            throw new runtime.RequiredError(
                'place',
                'Required parameter "place" was null or undefined when calling updateManyPlaces_51().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/places`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PlaceToJSON(requestParameters['place']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update multiple records
     */
    async updateManyPlaces_51(requestParameters: UpdateManyPlaces0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateManyPlaces_51Raw(requestParameters, initOverrides);
    }

    /**
     * Update multiple records
     */
    async updateManyPostsRaw(requestParameters: UpdateManyPostsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['filter'] == null) {
            throw new runtime.RequiredError(
                'filter',
                'Required parameter "filter" was null or undefined when calling updateManyPosts().'
            );
        }

        if (requestParameters['post'] == null) {
            throw new runtime.RequiredError(
                'post',
                'Required parameter "post" was null or undefined when calling updateManyPosts().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/posts`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PostToJSON(requestParameters['post']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update multiple records
     */
    async updateManyPosts(requestParameters: UpdateManyPostsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateManyPostsRaw(requestParameters, initOverrides);
    }

    /**
     * Update multiple records
     */
    async updateManyPosts_52Raw(requestParameters: UpdateManyPosts0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['filter'] == null) {
            throw new runtime.RequiredError(
                'filter',
                'Required parameter "filter" was null or undefined when calling updateManyPosts_52().'
            );
        }

        if (requestParameters['post'] == null) {
            throw new runtime.RequiredError(
                'post',
                'Required parameter "post" was null or undefined when calling updateManyPosts_52().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/posts`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PostToJSON(requestParameters['post']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update multiple records
     */
    async updateManyPosts_52(requestParameters: UpdateManyPosts0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateManyPosts_52Raw(requestParameters, initOverrides);
    }

    /**
     * Update multiple records
     */
    async updateManyReactionsRaw(requestParameters: UpdateManyReactionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['filter'] == null) {
            throw new runtime.RequiredError(
                'filter',
                'Required parameter "filter" was null or undefined when calling updateManyReactions().'
            );
        }

        if (requestParameters['reaction'] == null) {
            throw new runtime.RequiredError(
                'reaction',
                'Required parameter "reaction" was null or undefined when calling updateManyReactions().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/reactions`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: ReactionToJSON(requestParameters['reaction']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update multiple records
     */
    async updateManyReactions(requestParameters: UpdateManyReactionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateManyReactionsRaw(requestParameters, initOverrides);
    }

    /**
     * Update multiple records
     */
    async updateManyReactions_53Raw(requestParameters: UpdateManyReactions0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['filter'] == null) {
            throw new runtime.RequiredError(
                'filter',
                'Required parameter "filter" was null or undefined when calling updateManyReactions_53().'
            );
        }

        if (requestParameters['reaction'] == null) {
            throw new runtime.RequiredError(
                'reaction',
                'Required parameter "reaction" was null or undefined when calling updateManyReactions_53().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/reactions`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: ReactionToJSON(requestParameters['reaction']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update multiple records
     */
    async updateManyReactions_53(requestParameters: UpdateManyReactions0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateManyReactions_53Raw(requestParameters, initOverrides);
    }

    /**
     * Update record
     */
    async updatePlaceRaw(requestParameters: UpdatePlaceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Place>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updatePlace().'
            );
        }

        if (requestParameters['place'] == null) {
            throw new runtime.RequiredError(
                'place',
                'Required parameter "place" was null or undefined when calling updatePlace().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/places/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PlaceToJSON(requestParameters['place']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PlaceFromJSON(jsonValue));
    }

    /**
     * Update record
     */
    async updatePlace(requestParameters: UpdatePlaceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Place> {
        const response = await this.updatePlaceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update record
     */
    async updatePlace_54Raw(requestParameters: UpdatePlace0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Place>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updatePlace_54().'
            );
        }

        if (requestParameters['place'] == null) {
            throw new runtime.RequiredError(
                'place',
                'Required parameter "place" was null or undefined when calling updatePlace_54().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/places/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PlaceToJSON(requestParameters['place']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PlaceFromJSON(jsonValue));
    }

    /**
     * Update record
     */
    async updatePlace_54(requestParameters: UpdatePlace0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Place> {
        const response = await this.updatePlace_54Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update record
     */
    async updatePostRaw(requestParameters: UpdatePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Post>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updatePost().'
            );
        }

        if (requestParameters['post'] == null) {
            throw new runtime.RequiredError(
                'post',
                'Required parameter "post" was null or undefined when calling updatePost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/posts/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PostToJSON(requestParameters['post']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PostFromJSON(jsonValue));
    }

    /**
     * Update record
     */
    async updatePost(requestParameters: UpdatePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Post> {
        const response = await this.updatePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update record
     */
    async updatePost_55Raw(requestParameters: UpdatePost0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Post>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updatePost_55().'
            );
        }

        if (requestParameters['post'] == null) {
            throw new runtime.RequiredError(
                'post',
                'Required parameter "post" was null or undefined when calling updatePost_55().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/posts/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PostToJSON(requestParameters['post']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PostFromJSON(jsonValue));
    }

    /**
     * Update record
     */
    async updatePost_55(requestParameters: UpdatePost0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Post> {
        const response = await this.updatePost_55Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update record
     */
    async updateReactionRaw(requestParameters: UpdateReactionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Reaction>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateReaction().'
            );
        }

        if (requestParameters['reaction'] == null) {
            throw new runtime.RequiredError(
                'reaction',
                'Required parameter "reaction" was null or undefined when calling updateReaction().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/reactions/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: ReactionToJSON(requestParameters['reaction']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReactionFromJSON(jsonValue));
    }

    /**
     * Update record
     */
    async updateReaction(requestParameters: UpdateReactionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Reaction> {
        const response = await this.updateReactionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update record
     */
    async updateReaction_56Raw(requestParameters: UpdateReaction0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Reaction>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateReaction_56().'
            );
        }

        if (requestParameters['reaction'] == null) {
            throw new runtime.RequiredError(
                'reaction',
                'Required parameter "reaction" was null or undefined when calling updateReaction_56().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/reactions/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: ReactionToJSON(requestParameters['reaction']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReactionFromJSON(jsonValue));
    }

    /**
     * Update record
     */
    async updateReaction_56(requestParameters: UpdateReaction0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Reaction> {
        const response = await this.updateReaction_56Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates a stop and its associated days
     * Update a stop
     */
    async updateStopRaw(requestParameters: UpdateStopOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Stop>> {
        if (requestParameters['itineraryId'] == null) {
            throw new runtime.RequiredError(
                'itineraryId',
                'Required parameter "itineraryId" was null or undefined when calling updateStop().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateStop().'
            );
        }

        if (requestParameters['updateStopRequest'] == null) {
            throw new runtime.RequiredError(
                'updateStopRequest',
                'Required parameter "updateStopRequest" was null or undefined when calling updateStop().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/itineraries/{itineraryId}/stops/{id}`.replace(`{${"itineraryId"}}`, encodeURIComponent(String(requestParameters['itineraryId']))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateStopRequestToJSON(requestParameters['updateStopRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StopFromJSON(jsonValue));
    }

    /**
     * Updates a stop and its associated days
     * Update a stop
     */
    async updateStop(requestParameters: UpdateStopOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Stop> {
        const response = await this.updateStopRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates a stop and its associated days
     * Update a stop
     */
    async updateStop_57Raw(requestParameters: UpdateStop0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Stop>> {
        if (requestParameters['itineraryId'] == null) {
            throw new runtime.RequiredError(
                'itineraryId',
                'Required parameter "itineraryId" was null or undefined when calling updateStop_57().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateStop_57().'
            );
        }

        if (requestParameters['updateStopRequest'] == null) {
            throw new runtime.RequiredError(
                'updateStopRequest',
                'Required parameter "updateStopRequest" was null or undefined when calling updateStop_57().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/itineraries/{itineraryId}/stops/{id}`.replace(`{${"itineraryId"}}`, encodeURIComponent(String(requestParameters['itineraryId']))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateStopRequestToJSON(requestParameters['updateStopRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StopFromJSON(jsonValue));
    }

    /**
     * Updates a stop and its associated days
     * Update a stop
     */
    async updateStop_57(requestParameters: UpdateStop0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Stop> {
        const response = await this.updateStop_57Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Upload a file through the server which then uploads to Azure Blob Storage
     * Upload file to server (traditional approach)
     */
    async uploadFileRaw(requestParameters: UploadFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        if (requestParameters['file'] == null) {
            throw new runtime.RequiredError(
                'file',
                'Required parameter "file" was null or undefined when calling uploadFile().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['file'] != null) {
            formParams.append('file', requestParameters['file'] as any);
        }

        const response = await this.request({
            path: `/files`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Upload a file through the server which then uploads to Azure Blob Storage
     * Upload file to server (traditional approach)
     */
    async uploadFile(requestParameters: UploadFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.uploadFileRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Validates an Apple receipt and completes the order, adding credits to the account
     * Verify Apple IAP receipt and complete order
     */
    async verifyIAPReceiptRaw(requestParameters: VerifyIAPReceiptOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Order>> {
        if (requestParameters['accountId'] == null) {
            throw new runtime.RequiredError(
                'accountId',
                'Required parameter "accountId" was null or undefined when calling verifyIAPReceipt().'
            );
        }

        if (requestParameters['verifyIAPReceiptRequest'] == null) {
            throw new runtime.RequiredError(
                'verifyIAPReceiptRequest',
                'Required parameter "verifyIAPReceiptRequest" was null or undefined when calling verifyIAPReceipt().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/accounts/{accountId}/orders/verify-iap`.replace(`{${"accountId"}}`, encodeURIComponent(String(requestParameters['accountId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: VerifyIAPReceiptRequestToJSON(requestParameters['verifyIAPReceiptRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrderFromJSON(jsonValue));
    }

    /**
     * Validates an Apple receipt and completes the order, adding credits to the account
     * Verify Apple IAP receipt and complete order
     */
    async verifyIAPReceipt(requestParameters: VerifyIAPReceiptOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Order> {
        const response = await this.verifyIAPReceiptRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const RemoveReactionReactableTypeEnum = {
    Itinerary: 'itinerary',
    Post: 'post',
    Stop: 'stop'
} as const;
export type RemoveReactionReactableTypeEnum = typeof RemoveReactionReactableTypeEnum[keyof typeof RemoveReactionReactableTypeEnum];
/**
 * @export
 */
export const RemoveReactionReactionTypeEnum = {
    Like: 'like',
    Dislike: 'dislike'
} as const;
export type RemoveReactionReactionTypeEnum = typeof RemoveReactionReactionTypeEnum[keyof typeof RemoveReactionReactionTypeEnum];
/**
 * @export
 */
export const RemoveReaction0ReactableTypeEnum = {
    Itinerary: 'itinerary',
    Post: 'post',
    Stop: 'stop'
} as const;
export type RemoveReaction0ReactableTypeEnum = typeof RemoveReaction0ReactableTypeEnum[keyof typeof RemoveReaction0ReactableTypeEnum];
/**
 * @export
 */
export const RemoveReaction0ReactionTypeEnum = {
    Like: 'like',
    Dislike: 'dislike'
} as const;
export type RemoveReaction0ReactionTypeEnum = typeof RemoveReaction0ReactionTypeEnum[keyof typeof RemoveReaction0ReactionTypeEnum];
/**
 * @export
 */
export const SearchItinerariesVisibilityEnum = {
    Draft: 'DRAFT',
    Public: 'PUBLIC',
    Private: 'PRIVATE'
} as const;
export type SearchItinerariesVisibilityEnum = typeof SearchItinerariesVisibilityEnum[keyof typeof SearchItinerariesVisibilityEnum];
